<template>
    <div>
        <a-spin :spinning="spinning">
            <h2 v-if="promo.promo_type == '1' && profileId == 0">Create Simple Discount - {{promo.name}}</h2>
            <h2 v-else-if="promo.promo_type == '1' && profileId > 0">{{(viewOnly) ? "View" : "Edit" }} Simple Discount - {{promo.name}}</h2>
            <h2 v-if="promo.promo_type == '2' && profileId == 0">Create Multi-level Discount - {{promo.name}}</h2>
            <h2 v-else-if="promo.promo_type == '2' && profileId > 0">{{(viewOnly) ? "View" : "Edit" }} Multi-level Discount - {{promo.name}}</h2>
            <h2 v-if="promo.promo_type == '3' && profileId == 0">Create Buy X Take Y Discount - {{promo.name}}</h2>
            <h2 v-else-if="promo.promo_type == '3' && profileId > 0">{{(viewOnly) ? "View" : "Edit" }} Buy X Take Y Discount - {{promo.name}}</h2>
            <h2 v-if="promo.promo_type == '4' && profileId == 0">Create Pricing Scheme - {{promo.name}}</h2>
            <h2 v-else-if="promo.promo_type == '4' && profileId > 0">{{(viewOnly) ? "View" : "Edit" }} Pricing Scheme - {{promo.name}}</h2>
            <h2 v-if="promo.promo_type == '5' && profileId == 0">Create Coupon - {{promo.name}}</h2>
            <h2 v-else-if="promo.promo_type == '5' && profileId > 0">{{(viewOnly) ? "View" : "Edit" }} Coupon - {{promo.name}}</h2>
            <h2 v-if="promo.promo_type == '6' && profileId == 0">Create Conditional Promo - {{promo.name}}</h2>
            <h2 v-else-if="promo.promo_type == '6' && profileId > 0">{{(viewOnly) ? "View" : "Edit" }} Conditional Promo - {{promo.name}}</h2>

            <base-alert v-if="errors.length" type="danger">
                <b>You have the following error(s):</b>
                <li v-for="error in errors" :key="error">{{ error }}</li>
            </base-alert>

            <a-modal title="Mass Assign" :visible="modalVisible" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel" ok-text="Apply All">
                <fieldset :disabled="viewOnly">
                    <base-input label="Required" v-if="(promo.promo_type == '2' && promo.reward_type != '1')|| promo.promo_type == '3' || promo.promo_type == '5' || promo.promo_type == '6'">
                        <a-input v-model="massRequired" placeholder="Enter Required" />
                    </base-input>
                    <base-input label="Discount" v-if="((promo.promo_type != '6' && promo.promo_type != '3') && promo.promo_type != '4' && promo.promo_type != '5') || (promo.promo_type == '3' && promo.reward_type == '1')" >
                        <a-input v-model="massDiscount" placeholder="Enter Discount" />
                    </base-input>
                    <base-input label="Limit" v-if="(promo.promo_type != '6' && promo.promo_type != '3' && promo.promo_type != '5') || (promo.promo_type == '3' && promo.reward_type == '1')">
                        <a-input v-model="massLimit" placeholder="Enter Limit" />
                    </base-input>
                    <base-input label="Round" v-if="(promo.promo_type != '6' && promo.promo_type != '3' && promo.promo_type != '5') || (promo.promo_type == '3' && promo.reward_type == '1')" >
                        <a-input v-model="massRound" placeholder="Enter Round" />
                    </base-input>
                </fieldset>
            </a-modal>

            <!-- Available Fields Modal -->
            <a-modal title="Available Fields" :visible="modalAvailableFields"
            @cancel="handleCancel">
                <template slot="footer">
                    <a-button key="back" @click="handleCancel">Close</a-button>
                </template>
                <VueTabulator v-model="couponAvailableFieldsData" :options="couponAvailableFieldsOption"/>
            </a-modal>

            <hr>
            <div class="row no-gutters">
                <div class="col-md-2" style="border-right: 1px solid rgb(224, 224, 224);">
                    <a-steps direction="vertical" :current="current">
                        <a-step title="Info" />
                        <a-step title="Apply Promotion" />
                        <a-step title="Customers" />
                        <a-step title="Payment Types" />
                        <a-step title="Sites" />
                        <a-step title="POS Transaction Types"/>
                        <a-step v-if="showAdditionalPromoConfig" title="Additional Promo Configuration"/>  // visible to shakeys and peri-peri account only
                    </a-steps>
                </div>
                <div class="col-md-10">
                    <div class="card mb-3 border-0">
                        <!-- {{coupon}} -->
                        <!-- <form id="form-proper"> -->
                            <div v-if="current == 0" class="card-body">
                                <h2 class="card-title">Promo Information</h2>
                                <div class="row ml-3">
                                    <div class="col-md-12">
                                        <a-input label="Promo Name" v-model="promo.name" input-classes="form-control" style="margin-bottom: 0px;" placeholder="Enter a description for your promo" required :disabled="viewOnly" />
                                        <small>Example: 10% Off All Shirts</small>
                                        <br><br>
                                        <a-input label="Promo Shortcode" v-model="promo.code" input-classes="form-control" style="margin-bottom: 0px;" placeholder="Enter a short code to identify your promo" required :disabled="viewOnly" />
                                        <small>Example: PROMO10% (no spaces)</small>
                                        <br><br>
                                        <base-input label="Status"><br>
                                            <a-select  v-model="promo.status" style="width: 100%" @change="replaceStatus" :key="keyComp" :disabled="viewOnly">
                                                <a-select-option key="A" value="A">Active</a-select-option>
                                                <a-select-option key="I" value="I">In-Active</a-select-option>
                                                <a-select-option key="U" value="U" disabled>On-Going-Upload</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>
                                <div class="row ml-3">
                                    <div class="col-md-4">
                                        <h2 class="card-title" style="margin-bottom: 0px;">Reference Code Entry</h2>
                                        <base-checkbox class="mb-3 mt-3" v-model="promo.display_reference_code" :disabled="viewOnly">
                                            Display Prompt for Reference Code Entry
                                        </base-checkbox>
                                        <base-checkbox class="mb-3 mt-3" v-model="promo.require_reference_code" :disabled="viewOnly || !promo.display_reference_code">
                                            Require Reference Code Entry
                                        </base-checkbox>
                                    </div>
                                    <div class="col-md-4">
                                        <h2 class="card-title" style="margin-bottom: 0px;">Voucher Code Entry</h2>
                                        <base-checkbox class="mb-3 mt-3" v-model="promo.require_voucher_entry" :disabled="viewOnly">
                                            Require Voucher Code Entry
                                        </base-checkbox>
                                        <base-checkbox class="mb-3 mt-3" v-model="promo.check_online" :disabled="viewOnly || !promo.require_voucher_entry">
                                            Check Voucher Code Validity Online
                                        </base-checkbox>
                                        <base-checkbox class="mb-3 mt-3" v-model="promo.require_supercard_number" :disabled="viewOnly">
                                            Require Supercard Number
                                        </base-checkbox>
                                    </div>
                                     <div class="col-md-4">
                                        <h2 class="card-title" style="margin-bottom: 0px;">Approval Copy</h2>
                                        <base-checkbox class="mb-3 mt-3" v-model="promo.is_print_approval_copy" :disabled="viewOnly">
                                            Print approval copy
                                        </base-checkbox>
                                        
                                    </div>
                                </div>
                                <h2 class="card-title">Promo Duration</h2>
                                <div class="row ml-3">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <base-input label="Start Date">
                                                    <br><a-date-picker v-model="promo.start_date" :format="dateFormat" style="width: 100%" :disabled="viewOnly"/>
                                                    <small>Enter a valid start date</small>
                                                </base-input>
                                            </div>
                                            <div class="col-md-6">
                                                <base-input label="End Date">
                                                    <br><a-date-picker v-model="promo.end_date" :format="dateFormat" style="width: 100%" :disabled="viewOnly"/>
                                                    <small>Enter a valid end date</small>
                                                </base-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <base-input label="Start Time"><br>
                                                    <a-time-picker use12Hours v-model="promo.start_date" format="hh:mm A" style="width: 100%" :disabled="viewOnly"/>
                                                    <small>Enter a valid start time</small>
                                                </base-input>
                                            </div>
                                            <div class="col-md-6">
                                                <base-input label="End Time"><br>
                                                    <a-time-picker use12Hours v-model="promo.end_date" format="hh:mm A" style="width: 100%" :disabled="viewOnly"/>
                                                    <small>Enter a valid end time</small>
                                                </base-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-center mt-4">
                                    <button type="button" class="btn btn-sm btn-outline-secondary" @click='showAdvancedInfoDiv' >
                                        Advanced Information {{showAdvancedInfo? '↟' : '↡'}}
                                    </button>
                                </div>
                                <div v-if="showAdvancedInfo == true">
                                    <h2 class="card-title" style="margin-bottom: 0px;">Specify Valid Date &amp; Time</h2>
                                    <p>Set specific days and hours when this promotion is available (when not enabled, promotion is valid on all days and hours by default)</p>
                                    <div class="row ml-3">
                                        <div class="col-md-12">
                                            <base-checkbox class="mb-3 mt-3" v-model="is_specify_date" :disabled="viewOnly">
                                                <b>Specify Valid Days</b>
                                            </base-checkbox>
                                            <div class="ml-3">
                                                <span>Promos will only be enabled on the days selected</span><br><br>
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <base-checkbox v-model="valid_days.mon" :disabled="is_specify_date == false || viewOnly">
                                                            Monday
                                                        </base-checkbox>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <base-checkbox v-model="valid_days.thu" :disabled="is_specify_date == false || viewOnly">
                                                            Thursday
                                                        </base-checkbox>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <base-checkbox v-model="valid_days.sun" :disabled="is_specify_date == false || viewOnly">
                                                            Sunday
                                                        </base-checkbox>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <base-checkbox v-model="valid_days.tue" :disabled="is_specify_date == false || viewOnly">
                                                            Tuesday
                                                        </base-checkbox>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <base-checkbox v-model="valid_days.fri" :disabled="is_specify_date == false || viewOnly">
                                                            Friday
                                                        </base-checkbox>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <base-checkbox v-model="valid_days.wed" :disabled="is_specify_date == false || viewOnly">
                                                            Wednesday
                                                        </base-checkbox>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <base-checkbox v-model="valid_days.sat" :disabled="is_specify_date == false || viewOnly">
                                                            Saturday
                                                        </base-checkbox>
                                                    </div>
                                                </div>
                                            </div>

                                            <base-checkbox class="mb-3 mt-3" v-model="is_specify_time" :disabled="viewOnly">
                                                <b>Specify Valid Time</b>
                                            </base-checkbox>
                                            <div class="ml-3">
                                                <span>Promos will only be enabled on the hours specified</span><br><br>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <base-input label="Start Time"><br>
                                                            <a-time-picker use12Hours v-model="picker_date.valid_start_time" format="hh:mm A" style="width: 100%" :disabled="is_specify_time == false || viewOnly"/>
                                                            <small>Enter a valid start time</small>
                                                        </base-input>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <base-input label="End Time"><br>
                                                            <a-time-picker use12Hours v-model="picker_date.valid_end_time" format="hh:mm A" style="width: 100%" :disabled="is_specify_time == false || viewOnly"/>
                                                            <small>Enter a valid end time</small>
                                                        </base-input>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="current == 1" class="card-body">
                                <h2 class="card-title">Apply Promotion</h2>
                                <div class="row ml-3">
                                    <div class="col-md-12">
                                        <base-input label="Promotion Type"><br>
                                            <a-select v-if="promo.promo_type == '1'" v-model="promo.reward_type" style="width: 100%" @change="replaceDiscount" :disabled="viewOnly">
                                                <a-select-option v-for="option in rewardTypeOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                            </a-select>
                                            <a-select v-else-if="promo.promo_type == '2'" v-model="promo.reward_type" style="width: 100%" @change="replaceDiscount" :disabled="viewOnly">
                                                <a-select-option v-for="option in multiLevelTypeOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                            </a-select>
                                            <a-select v-else-if="promo.promo_type == '3'" v-model="promo.reward_type" style="width: 100%" @change="replaceDiscount" :disabled="viewOnly">
                                                <a-select-option v-for="option in buyXOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                            </a-select>
                                            <a-select v-else-if="promo.promo_type == '4'" v-model="promo.reward_type" style="width: 100%" @change="replaceDiscount" :disabled="viewOnly">
                                                <a-select-option v-for="option in pricingOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                            </a-select>
                                            <a-select v-else-if="promo.promo_type == '5'" v-model="promo.reward_type" style="width: 100%" @change="replaceDiscount" :disabled="viewOnly">
                                                <a-select-option v-for="option in couponOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                            </a-select>
                                            <a-select v-else-if="promo.promo_type == '6'" v-model="promo.reward_type" style="width: 100%" @change="replaceDiscount" :disabled="viewOnly">
                                                <a-select-option v-for="option in condtionalOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                            </a-select>
                                            <small>{{reward_type_description}}</small>
                                        </base-input>
                                    </div>
                                </div>

                                <div class="row ml-3">
                                    <div class="col-md-6">
                                        <base-input label="Priority" >
                                            <a-input type="number" min="0" v-model="promo.priority" placeholder="Enter Priority Number" :disabled="viewOnly"/>
                                        </base-input>
                                    </div>
                                </div>

                                <div v-if="promo.promo_type == '1' && (promo.reward_type == '1' || promo.reward_type == '2')" class="row ml-3">
                                    <div class="col-md-6">
                                        <base-input label="Minimum Amount" >
                                            <a-input type="number" min="0" v-model="min_amount" placeholder="Enter Minimum Amount Required to Apply Promotion" :disabled="viewOnly"/>
                                        </base-input>
                                    </div>
                                </div>

                                <h2 class="card-title">Select Items</h2>
                                <div class="row ml-3">
                                    <div class="col-md-12">
                                        <div v-if="(promo.promo_type == '5' && include_item != '6') || (promo.promo_type == '1' && (promo.reward_type == '1' || promo.reward_type == '2') && include_item != '6')" class="row">
                                            <div class="col-md-6">
                                                <base-input label="Include Items"><br>
                                                    <a-select v-model="include_item" style="width: 100%" :disabled="viewOnly">
                                                        <a-select-option v-for="option in includeItemOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                                    </a-select>
                                                </base-input>
                                            </div>
                                            <div v-if="include_item == '2'" class="col-md-6">
                                                <base-input label="Select Supplier" :disabled="viewOnly"><br>
                                                    <a-select v-model="allItem.supplier_id" showSearch placeholder="Select Supplier" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="searchSupplier">
                                                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                                    <a-select-option v-for="option in supplierOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>
                                            </div>

                                            <div v-if="include_item == '3'" class="col-md-6">
                                                <base-input label="Select Brand" :disabled="viewOnly"><br>
                                                    <a-select v-model="allItem.brand_id" showSearch placeholder="Select Brand" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="searchBrand">
                                                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                                    <a-select-option v-for="option in brandOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>
                                            </div>

                                            <div v-if="include_item == '4'" class="col-md-6">
                                                <base-input label="Select Category" :disabled="viewOnly"><br>
                                                    <a-cascader v-model="inputCategory" :options="categoriesOptions" :showSearch="{filter}"
                                                    placeholder="All Categories" style="width: 100%" changeOnSelect />
                                                </base-input>
                                            </div>

                                            <div v-if="include_item == '5'" class="col-md-12">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <h3 class="card-title">These items will not be included:</h3>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <button class="btn btn-dark btn-sm" @click="showDrawer">Add Exception</button>
                                                    </div>
                                                </div>

                                                <div class="table-responsive">
                                                    <VueTabulator ref="tabulator" v-model="exceptData" :options="exceptOptions" :key="refKey" />
                                                </div>
                                            </div>

                                            <div v-if="promo.promo_type == '1'" class="col-md-12">
                                                <base-input v-if="promo.reward_type == '1'" label="Percent Discount" >
                                                    <a-input type="number" min="0" v-model="discount" addonAfter="%" placeholder="Enter Percent Discount" :disabled="viewOnly"/>
                                                </base-input>
                                                <base-input v-else label="Amount Discount" v-model="discount" input-classes="form-control" placeholder="Enter Amount Discount" :disabled="viewOnly"/>
                                                <base-input v-if="promo.reward_type == '1'" label="Maximum Discount" v-model="max_discount" input-classes="form-control" placeholder="Enter Maximum Discount Allowed" :disabled="viewOnly"/>
                                            </div>
                                        </div>
                                        <div v-else-if="(promo.promo_type == '5' && include_item == '6') || promo.promo_type == '4' || promo.promo_type == '6' || promo.promo_type == '3' || promo.promo_type == '2' || (promo.promo_type == '1' && (promo.reward_type == '3' || include_item == '6'))" class="row">
                                            <div v-if="(promo.promo_type == '1' || promo.promo_type == '5') && promo.reward_type != '3'" class="col-md-6">
                                                <base-input label="Include Items"><br>
                                                    <a-select v-model="include_item" style="width: 100%" :disabled="viewOnly">
                                                        <a-select-option v-for="option in includeItemOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                                    </a-select>
                                                </base-input>
                                                <base-input label="Amount Discount" v-model="discount" input-classes="form-control" placeholder="Enter Amount Discount" :disabled="viewOnly"/>
                                                 <base-input v-if="promo.reward_type == '1'" label="Maximum Discount" v-model="max_discount" input-classes="form-control" placeholder="Enter Maximum Discount Allowed" :disabled="viewOnly"/>
                                            </div>

                                            <div v-else-if="promo.promo_type == '2' && promo.reward_type != '1'" class="col-md-6">
                                                <div class="row" >
                                                    <div class="col-md-6">
                                                        <base-radio name="IH" v-model="reward.apply_level" :disabled="viewOnly">
                                                            Header Level
                                                        </base-radio>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <base-radio name="IL" v-model="reward.apply_level" :disabled="viewOnly">
                                                            Line Level
                                                        </base-radio>
                                                    </div>
                                                </div>
                                                <br><br>
                                                <base-input v-if="promo.reward_type == '2' && reward.apply_level == 'IH'" label="Minimum Amount" v-model="reward.required_value" input-classes="form-control" placeholder="Enter a amount" :disabled="viewOnly"/>
                                                <base-input v-else-if="promo.reward_type == '3' && reward.apply_level == 'IH'" label="Required Quantity" v-model="reward.required_value" input-classes="form-control" placeholder="Enter a quantity" :disabled="viewOnly"/>
                                                <div class="row" v-if="reward.apply_level =='IH'">
                                                    <div class="col-md-3">
                                                        <base-radio name="IL" v-model="reward.apply_discount">
                                                            Apply Discount to Gross
                                                        </base-radio>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <base-radio name="NET" v-model="reward.apply_discount">
                                                            Apply Discount on Net
                                                        </base-radio>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-12">
                                                <a-tabs default-active-key="1">
                                                    <a-tab-pane key="1">
                                                        <span slot="tab">
                                                            <span class="numberCircle">1</span>
                                                            Search
                                                        </span>

                                                        <div v-if="promo.promo_type == '6' && promo.reward_type == '2'" class="col-md-4">
                                                            <base-input label="Pair Options"><br>
                                                                <a-select v-model="coupleType" style="width: 100%" :disabled="viewOnly">
                                                                    <a-select-option v-for="option in coupleTypeOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                                                </a-select>
                                                            </base-input>
                                                        </div>

                                                        <h2 v-if="promo.promo_type == '3' && promo.reward_type == '2'" class="card-title">Select Item X</h2>
                                                        <h2 v-else-if="promo.promo_type == '6' && promo.reward_type == '2' && coupleType == ''" class="card-title">
                                                          Select Item List A (Prerequisite Items)
                                                        </h2>
                                                        <h2 v-else-if="promo.promo_type == '6' && promo.reward_type == '2' && coupleType != ''" class="card-title">Select Item List</h2>

                                                        <div class="row no-gutters">
                                                            <div class="col-md-12 mb-3">
                                                                <b-input-group>
                                                                    <template v-slot:prepend>
                                                                        <b-dropdown :text="filterCaption" variant="outline-default">
                                                                            <b-dropdown-item @click.prevent="changeFilter('name')">Name</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('id')">Product Code</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('barcode')">Barcode</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('stock_no')">Stock No</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('reference_code')">Reference Code</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('shelf_code')">Shelf Code</b-dropdown-item>
                                                                        </b-dropdown>
                                                                    </template>
                                                                    <b-form-input style="padding:5px; height: 44px;" @keypress.enter="allProductsData" v-model="searchText">{{searchText}}</b-form-input>

                                                                    <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12" style="border-top: 1px solid #e0e0e0; width: 100%">
                                                                        <product-advance-filter :currentFilter="currentFilter" :parentParams="filterParams" :massUpdateMode="massUpdateMode" @changeParams="changeParams" @closeFilter="closeFilter" :key="filterKey"> </product-advance-filter>
                                                                    </div>

                                                                    <div class="filter-cont">
                                                                      <button
                                                                        class="btn btn-sm float-right mr-10"
                                                                        style="background-color: #394A5D; color: white;"
                                                                        @click.prevent="advanceFilter(true)">
                                                                        {{toggleLabel}}
                                                                      </button>&nbsp;&nbsp;

                                                                      <base-button
                                                                        v-if="!viewOnly"
                                                                        type="default"
                                                                        class="btn btn-sm float-right mr-10"
                                                                        style="background-color: #394A5D; color: white;"
                                                                        @click.prevent="addAll">
                                                                        Add All
                                                                      </base-button>

                                                                      <base-dropdown
                                                                        class="ellisis-cont nav-link pr-0 float-right"
                                                                        position="right">

                                                                        <div class="media align-items-center" slot="title">
                                                                          <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                                                                        </div>

                                                                        <template>
                                                                          <div class="dropdown-header noti-title">
                                                                            <h6 class="text-overflow m-0">PRODUCT LIST ACTIONS</h6>
                                                                          </div>
                                                                          <div
                                                                            v-if="canUploadProduct"
                                                                            class="dropdown-item"
                                                                            @click.prevent="toggleUploadProductsDrawer(true)">
                                                                            <i class="fa fa-upload"></i>
                                                                            <span>Import</span>
                                                                          </div>
                                                                          <div
                                                                            v-if="canExportProduct"
                                                                            class="dropdown-item"
                                                                            @click.prevent="exportProduct">
                                                                            <i class="fa fa-download"></i>
                                                                            <span>Export</span>
                                                                          </div>
                                                                        </template>
                                                                      </base-dropdown>
                                                                    </div>
                                                                </b-input-group>
                                                            </div>
                                                        </div>

                                                        <base-checkbox class="ml-1" v-model="is_ref_code">
                                                            View promotion by reference code
                                                        </base-checkbox>

                                                        <div v-if="changeDisplay == true" class="table-responsive">
                                                            <div id="product-table" ></div>
                                                            <VueTabulator ref="tabulator" v-model="productData" :options="productOptions" style="display:none;" :key="refKey"/>
                                                        </div>

                                                        <div v-else class="table-responsive">
                                                            <div id="product-table" style="display:none;"></div>
                                                            <VueTabulator ref="tabulator" v-model="productData" :options="productOptions" :key="refKey"/>
                                                        </div>

                                                        <h2 v-if="promo.promo_type == '6' && promo.reward_type == '2' && coupleType == ''" class="card-title">
                                                          Select Item List B (Bonus Items)
                                                        </h2>
                                                        <div v-if="promo.promo_type == '6' && promo.reward_type == '2' && coupleType == ''" class="row no-gutters">
                                                            <div class="col-md-12 mb-3">
                                                                <b-input-group>
                                                                    <template v-slot:prepend>
                                                                        <b-dropdown :text="filterCaptionB" variant="outline-default">
                                                                            <b-dropdown-item @click.prevent="changeFilter('name')">Name</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('id')">Product Code</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('barcode')">Barcode</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('stock_no')">Stock No</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('reference_code')">Reference Code</b-dropdown-item>
                                                                            <b-dropdown-item @click.prevent="changeFilter('shelf_code')">Shelf Code</b-dropdown-item>
                                                                        </b-dropdown>
                                                                    </template>
                                                                    <b-form-input style="padding:5px; height: 44px;" @keypress.enter="allProductsDataB" v-model="searchTextB">{{searchTextB}}</b-form-input>
                                                                </b-input-group>
                                                            </div>
                                                        </div>

                                                        <div v-if="promo.promo_type == '6' && promo.reward_type == '2' && changeDisplayB == true && coupleType == ''" class="table-responsive">
                                                            <div id="product-tableB" ></div>
                                                            <VueTabulator ref="tabulator" v-model="productDataB" :options="productOptionsB" style="display:none;" :key="refKey"/>
                                                        </div>

                                                        <div v-else-if="promo.promo_type == '6' && promo.reward_type == '2' && changeDisplayB == false && coupleType == ''" class="table-responsive">
                                                            <div id="product-tableB" style="display:none;"></div>
                                                            <VueTabulator ref="tabulator" v-model="productDataB" :options="productOptionsB" :key="refKey"/>
                                                        </div>
                                                    </a-tab-pane>
                                                    <a-tab-pane key="2">
                                                        <span slot="tab">
                                                            <span class="numberCircle">2</span>
                                                            Item List
                                                        </span>

                                                        <div v-if="promo.promo_type == '6' && promo.reward_type == '2'" class="col-md-4">
                                                            <base-input label="Pair Options"><br>
                                                                <a-select v-model="coupleType" style="width: 100%" :disabled="viewOnly">
                                                                    <a-select-option v-for="option in coupleTypeOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                                                </a-select>
                                                            </base-input>
                                                        </div>

                                                        <h2 v-if="promo.promo_type == '6' && promo.reward_type == '2' && coupleType == ''" class="card-title">
                                                          Select Item A (Prerequisite Items)
                                                        </h2>

                                                        <base-button v-if="(promo.promo_type == '5' && promo.reward_type == '2') == false" type="default" class="btn float-right mr-0" size="sm" :disabled="viewOnly" @click.prevent="massAssign">Mass Assign</base-button>

                                                        <h2 v-if="promo.promo_type == '3' && promo.reward_type == '2'" class="card-title">Select Item X</h2>
                                                        <div v-if="promo.promo_type == '4'" class="row">
                                                            <div class="col-8">
                                                                <fieldset>
                                                                    <VueTabulator ref="tabulator" v-model="selectedProductData" :options="schemeOptions" @row-click="setActiveProductId" :key="refKey"/>
                                                                </fieldset>
                                                            </div>
                                                            <div class="col-4">
                                                                <button type="button" class="btn btn-sm btn-primary float-right" style="margin-bottom: 0px" @click.prevent="levelHandleAdd">ADD LEVEL</button>
                                                                <h3 class="ml-3">LEVELS</h3>
                                                                <h4 class="ml-3">{{activeProductName}}</h4>
                                                                <a-table :columns="levelColumns" :dataSource="levelDataFilter" :pagination="false" :scroll="{ y: 400 }">
                                                                    <template v-for="col in ['qty', 'price']"
                                                                        :slot="col" slot-scope="text, record">
                                                                        <div :key="col">
                                                                            <div>
                                                                                <a-input v-if="record.editable" type="number" min="0" style="margin: -5px 0" :value="text"
                                                                                    @change="e => levelHandleChangeTable(e.target.value, record.key, col)" />
                                                                                <template v-else>{{text}}</template>
                                                                            </div>
                                                                        </div>
                                                                    </template>
                                                                    <template slot="operation" slot-scope="text, record">
                                                                        <div class="editable-row-operations">
                                                                            <a-dropdown>
                                                                                <a class="ant-dropdown-link">
                                                                                    <span class="fa fa-ellipsis-v"></span>
                                                                                </a>
                                                                                <a-menu slot="overlay">
                                                                                    <a-menu-item key=1 v-if="levelDataFilter.length">
                                                                                        <a-popconfirm title="Sure to delete?" @confirm="() => levelOnDelete(record.key)">
                                                                                            <a href="javascript:;">Delete</a>
                                                                                        </a-popconfirm>
                                                                                    </a-menu-item>
                                                                                </a-menu>
                                                                            </a-dropdown>
                                                                        </div>
                                                                    </template>
                                                                </a-table>
                                                            </div>
                                                        </div>
                                                        <div v-else-if="promo.promo_type == '5'" class="row">
                                                            <div v-if="promo.reward_type == '1'" class="col-md-12">
                                                                <base-input label="Select Promo Criteria"><br>
                                                                    <base-radio name="IL" v-model="reward.apply_level">
                                                                        Apply promotion upon purchase of <b><u>any</u> of the promo items</b>
                                                                    </base-radio>
                                                                    <base-radio name="IH" v-model="reward.apply_level">
                                                                        Apply promotion upon purchase of <b><u>all</u> promo items</b>
                                                                    </base-radio>
                                                                </base-input>

                                                                <base-input  label="Combination of Items Required to Trigger Promotion">
                                                                    &nbsp;
                                                                </base-input>
                                                                <fieldset :disabled="viewOnly">
                                                                    <VueTabulator ref="tabulator" v-model="selectedProductData" :options="couponLineOptions" :key="refKey"/>
                                                                </fieldset>
                                                                <!-- <VueTabulator v-else ref="tabulator" v-model="selectedProductData" :options="couponHeaderOptions"/> -->
                                                            </div>
                                                            <div v-else class="col-md-12">
                                                                <div>
                                                                    <fieldset :disabled="viewOnly">
                                                                    <VueTabulator ref="tabulator" v-model="selectedProductData" :options="couponHeaderOptions" :key="refKey"/>
                                                                    </fieldset>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-else class="table-responsive">
                                                            <fieldset >
                                                                <div v-if="showAddedProductTabulator">
                                                                    <!-- item list search field -->
                                                                    <div class="row no-gutters">
                                                                        <div class="col-md-12 mb-3">
                                                                            <b-input-group>
                                                                                <template v-slot:prepend>
                                                                                    <b-dropdown :text="filterCaptionC" variant="outline-default" >
                                                                                        <b-dropdown-item @click.prevent="setFilterField('name')">Name</b-dropdown-item>
                                                                                        <b-dropdown-item @click.prevent="setFilterField('barcode')">Barcode</b-dropdown-item>
                                                                                    </b-dropdown>
                                                                                </template>
                                                                                <b-form-input style="padding:5px; height: 44px;" v-model="filterValue">{{filterValue}}</b-form-input>
                                                                                <div class="filter-cont">
                                                                                    <button
                                                                                        class="btn btn-sm float-right mr-10"
                                                                                        style="background-color: #394A5D; color: white;"
                                                                                        @click.prevent="clearFilter">
                                                                                        Clear Filter
                                                                                    </button>&nbsp;&nbsp;
                                                                                </div>
                                                                            </b-input-group>
                                                                        </div>   
                                                                    </div>

                                                                    <VueTabulator v-if="promo.promo_type == '2' && promo.reward_type != '1' && reward.apply_level == 'IL'"
                                                                    ref="addedProductTabulator"
                                                                    v-model="selectedProductData"
                                                                    :options="selectedInlineProductOptions"
                                                                    :key="refKey"
                                                                    :integration="{ updateStrategy: 'UPDATE' }"/>
                                                                    <VueTabulator v-else-if="promo.promo_type == '3' && promo.reward_type == '1'"
                                                                    ref="addedProductTabulator"
                                                                    v-model="selectedProductData"
                                                                    :options="selectedBuyXGetXProductOptions"
                                                                    :key="refKey"
                                                                    :integration="{ updateStrategy: 'UPDATE' }"/>
                                                                    <VueTabulator v-else-if="promo.promo_type == '3' && promo.reward_type == '2'"
                                                                    ref="addedProductTabulator"
                                                                    v-model="selectedProductData"
                                                                    :options="selectedBuyXGetYProductOptions"
                                                                    :key="refKey"
                                                                    :integration="{ updateStrategy: 'UPDATE' }"/>
                                                                    <VueTabulator v-else-if="promo.promo_type == '6'"
                                                                    ref="addedProductTabulator"
                                                                    v-model="selectedProductData"
                                                                    :options="selectedBuyXGetYProductOptions"
                                                                    :key="refKey"
                                                                    :integration="{ updateStrategy: 'UPDATE' }"/>
                                                                    <VueTabulator v-else
                                                                    ref="addedProductTabulator"
                                                                    v-model="selectedProductData"
                                                                    :options="selectedProductOptions"
                                                                    :key="refKey"
                                                                    :integration="{ updateStrategy: 'UPDATE' }"/>
                                                                </div>
                                                            </fieldset>
                                                        </div>

                                                        <h2 v-if="promo.promo_type == '6' && promo.reward_type == '2' && coupleType == '1'" class="card-title">Higher Price Item Discount</h2>
                                                        <h2 v-else-if="promo.promo_type == '6' && promo.reward_type == '2' && coupleType == '2'" class="card-title">First Item Discount</h2>
                                                        <div class="row" v-if="promo.promo_type == '6' && promo.reward_type == '2' && coupleType != ''">
                                                            <div class="col-md-3">
                                                                <base-radio name="LSP" v-model="get_x_type">
                                                                    Percent Discount
                                                                </base-radio><br>
                                                                <base-input>
                                                                    <a-input :disabled="get_x_type != 'LSP'" type="number" min="0" v-model="reward.get_x_lp" addonAfter="%" placeholder="Enter Percent Discount" size="large"/>
                                                                </base-input>
                                                                <base-input label="Round to nearest">
                                                                    <a-input-number placeholder="Round to Nearest"
                                                                                    size="large"
                                                                                    style="width: 100%"
                                                                                    v-model="reward.get_x_lp_round"
                                                                                    :disabled="get_x_type != 'LSP'"
                                                                                    :min="0"
                                                                                    :precision="0"/>
                                                                </base-input>
                                                            </div>
                                                            <div class="col-md-3">
                                                                <base-radio name="LSA" v-model="get_x_type">
                                                                    Amount Discount
                                                                </base-radio><br>
                                                                <base-input :disabled="get_x_type != 'LSA'" v-model="reward.get_x_la" input-classes="form-control" placeholder="Enter Amount Discount" />
                                                            </div>
                                                            <div class="col-md-3">
                                                                <base-radio name="NWP" v-model="get_x_type">
                                                                    New Price
                                                                </base-radio><br>
                                                                <base-input :disabled="get_x_type != 'NWP'" v-model="reward.get_x_po" input-classes="form-control" placeholder="Enter Amount Discount" />
                                                            </div>
                                                        </div>

                                                        <div v-if="(promo.promo_type == '3' && promo.reward_type == '2') || promo.promo_type == '6'" class="row">
                                                            <div class="col-12">
                                                                <hr>
                                                                <h2 v-if="promo.promo_type == '6' && promo.reward_type == '1'" class="card-title">Select Item X</h2>
                                                                <h2 v-else-if="promo.promo_type == '6' && promo.reward_type == '2' && coupleType == ''" class="card-title">
                                                                  Select Item B (Bonus Items)
                                                                </h2>
                                                                <h2 v-else-if="coupleType == ''" class="card-title">Select Item Y</h2>
                                                                <h2 v-else-if="coupleType == '1'" class="card-title">Lower Price Item Discount</h2>
                                                                <h2 v-else-if="coupleType == '2'" class="card-title">Second Item Discount</h2>

                                                                <div v-if="(promo.promo_type == '6' &&
                                                                            promo.reward_type == '2' &&
                                                                            coupleType == '')">
                                                                            <fieldset :disabled="viewOnly">
                                                                                <VueTabulator ref="tabulator" v-model="selectedProductDataB" :options="selectedListBProductOptions" :key="refKey"/>
                                                                            </fieldset>
                                                                </div>

                                                                <div v-else-if="coupleType == ''">
                                                                    <a-input-group compact>
                                                                        <a-select v-model="searchFilter" defaultValue="name" style="width: 35%" size="large">
                                                                        <a-select-option value="name">Search by Name</a-select-option>
                                                                        <a-select-option value="barcode">Search by Barcode</a-select-option>
                                                                        <a-select-option value="stock_no">Search by Stock No.</a-select-option>
                                                                        <a-select-option value="reference_code">Search by Reference Code</a-select-option>
                                                                        </a-select>

                                                                        <autocomplete style="width: 65%; margin-top: -2px;" ref="autocomplete" placeholder="Search Products" :source="productsEndpoint"
                                                                            input-class="form-control" results-property="data" :results-display="formattedDisplay" :request-headers="authHeaders" @selected="getProduct">
                                                                        </autocomplete>
                                                                    </a-input-group>
                                                                    <br>
                                                                    <div class="table-responsive">
                                                                        <fieldset :disabled="viewOnly">
                                                                            <VueTabulator ref="tabulator" v-model="getYData" :options="selectedGetYProductOptions" :key="refKey"/>
                                                                        </fieldset>
                                                                    </div>
                                                                </div>

                                                                <div class="row" >
                                                                    <div class="col-md-3">
                                                                        <base-radio name="LP" v-model="get_y_type">
                                                                            Percent Discount
                                                                        </base-radio><br>
                                                                        <base-input>
                                                                            <a-input :disabled="get_y_type != 'LP'" type="number" min="0" v-model="reward.get_y_lp" addonAfter="%" placeholder="Enter Percent Discount" size="large"/>
                                                                        </base-input>
                                                                        <base-input label="Round to nearest">
                                                                            <a-input-number placeholder="Round to Nearest"
                                                                                            size="large"
                                                                                            style="width: 100%"
                                                                                            v-model="reward.get_y_lp_round"
                                                                                            :disabled="get_y_type != 'LP'"
                                                                                            :min="0"
                                                                                            :precision="0"/>
                                                                        </base-input>
                                                                    </div>
                                                                    <div class="col-md-3">
                                                                        <base-radio name="LA" v-model="get_y_type">
                                                                            Amount Discount
                                                                        </base-radio><br>
                                                                        <base-input :disabled="get_y_type != 'LA'" v-model="reward.get_y_la" input-classes="form-control" placeholder="Enter Amount Discount" />
                                                                    </div>
                                                                    <div class="col-md-3">
                                                                        <base-radio name="PO" v-model="get_y_type">
                                                                            New Price
                                                                        </base-radio><br>
                                                                        <base-input :disabled="get_y_type != 'PO'" v-model="reward.get_y_po" input-classes="form-control" placeholder="Enter Amount Discount" />
                                                                    </div>
                                                                    <div v-if="coupleType == ''" class="col-md-3">
                                                                        <base-radio name="FB" v-model="get_y_type">
                                                                            Free
                                                                        </base-radio>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a-tab-pane>
                                                    <!-- <a-tab-pane v-if="promo.promo_type != '5'" key="3">
                                                        <span slot="tab">
                                                            <span class="numberCircle">3</span>
                                                            Additional Settings
                                                        </span>
                                                        <div class="row ml-3">
                                                            <div class="col-md-12">
                                                                <base-checkbox v-model="is_no_of_times">
                                                                    Limit Number of times promo can be applied
                                                                </base-checkbox>
                                                                <div class="row ml-3">
                                                                    <div class="col-md-12">
                                                                        <base-input label="Maximum times" v-model="reward.max_application" input-classes="form-control" placeholder="Enter a limit" :disabled="is_no_of_times == false"/>
                                                                    </div>
                                                                </div>

                                                                <base-checkbox v-model="is_round_result">
                                                                    Round result to the nearest amount in (favor of mechant)
                                                                </base-checkbox>

                                                                <div class="row ml-3">
                                                                    <div class="col-md-12">
                                                                        <base-input label="Round-off" v-model="reward.round_to_nearest" input-classes="form-control" placeholder="Enter a round-off" :disabled="is_round_result == false"/>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a-tab-pane> -->
                                                </a-tabs>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="promo.promo_type == '5'">
                                    <!-- <div v-if="include_item != '1' && promo.reward_type == '2'" class="row ml-1" >
                                        <div class="col-12">
                                            <div class="row">
                                                <a-radio-group v-model="reward.apply_header" style="margin-bottom: 16px">
                                                    <a-radio-button value="IL">
                                                        Based on Item
                                                    </a-radio-button>
                                                    <a-radio-button value="IH">
                                                        Based on Receipt
                                                    </a-radio-button>
                                                </a-radio-group>
                                            </div>
                                            <div class="row">
                                                <p><i class="far fa-lightbulb"></i> Customer must purchase the required of any item on the list to trigger the promotion</p>
                                            </div>
                                        </div>
                                    </div> -->

                                    <div v-if="(promo.reward_type == '1' && include_item != '6') || promo.reward_type == '2'" class="row ml-3">
                                        <div class="col-4">
                                            <base-input v-if="promo.reward_type == '1'" label="Quantity Required" >
                                                <a-input type="number" min="0" v-model="coupon.coupon_required" />
                                                <small>{{coupon_description}}</small>
                                            </base-input>
                                            <base-input v-else label="Amount Required" >
                                                <a-input type="number" min="0" v-model="coupon.coupon_required" />
                                                <small>{{coupon_description}}</small>
                                            </base-input>
                                        </div>
                                    </div>

                                    <!-- <div v-if="reward.apply_header == 'IH' && include_item != '1' && promo.reward_type == '2'" class="row">
                                        <div class="col-12">
                                            <base-input label="Select Computation Method"><br>
                                                <base-radio name="IH" v-model="reward.apply_level">
                                                    Compute purchase amount, <b>inclusive of non-promo items</b>
                                                </base-radio>
                                                <base-radio name="IL" v-model="reward.apply_level">
                                                    Compute purchase amount, <b>exclusive of non-promo items</b><br>
                                                    <small>System will only compute the total amount of the items tagged to the promotion</small>
                                                </base-radio>
                                            </base-input>
                                        </div>
                                    </div> -->

                                    <h2 class="card-title">Coupon Settings</h2>
                                    <div class="row ml-3">
                                        <div class="col-md-5">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <base-input label="Reward Amount" >
                                                        <a-input type="number" min="0" v-model="coupon.coupon_amount" placeholder="Enter Reward Amount" :disabled="viewOnly"/>
                                                    </base-input>
                                                </div>
                                                <div class="col-md-6">
                                                    <base-input label="Coupon Expiry Date" >
                                                        <br><a-date-picker v-model="coupon.coupon_expired" :format="dateFormat" style="width: 100%" :disabled="viewOnly"/>
                                                    </base-input>
                                                </div>
                                            </div>
                                            <base-checkbox v-model="is_coupon_limit_printing">
                                                <b>Limit Coupon Printing</b><br>
                                                Place a limit on the number of coupons to be printed each time the transaction meets the criteria above.
                                            </base-checkbox>
                                            <div class="row ml-3">
                                                <div class="col-12">
                                                    <base-input label="Maximum Coupons" >
                                                        <a-input type="number" min="0" v-model="coupon.coupon_maximum" placeholder="Enter Maximum Coupons" :disabled="is_coupon_limit_printing == false || viewOnly" />
                                                    </base-input>
                                                </div>
                                            </div>
                                            <div class="row ml-3 mb-3">
                                                <div class="col-12">
                                                    <base-checkbox v-model="coupon.is_coupon_print_one" :disabled="is_coupon_limit_printing == false">
                                                        Print as one coupon
                                                    </base-checkbox>
                                                </div>
                                            </div>
                                            <!-- <base-input label="Coupon Message">
                                                <textarea rows="10" class="form-control" v-model="coupon.coupon_message"/>
                                            </base-input> -->
                                        </div>
                                        <!-- ADDITIONAL FIELDS -->
                                        <div class="col-md-12">
                                            <div class="row">
                                                <div class="col-md-5">
                                                <base-input label="Coupon Message">
                                                   <textarea rows="10" class="form-control" v-model="coupon.coupon_message"/>
                                                </base-input>
                                            </div>
                                            <button type="button" class="ant-btn ant-btn-primary" @click="showAvailableFields">Available Fields</button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div v-if="current == 2" class="card-body">
                                <fieldset :disabled="viewOnly">
                                    <h2 class="card-title">Select Customers</h2>
                                    <div class="row ml-3">
                                        <div class="col-md-12">
                                            <base-radio name="A" v-model="customer_type">
                                                All Customers (Members and Non-Members)
                                                <br><small>Default Section</small>
                                            </base-radio>
                                            <br>
                                            <base-radio name="M" v-model="customer_type">
                                                Members Only
                                            </base-radio>
                                            <br>
                                            <base-radio name="N" v-model="customer_type">
                                                Non-Members Only
                                            </base-radio>
                                            <br>
                                            <base-radio name="S" v-model="customer_type">
                                                Members of Specific Card Types Only
                                            </base-radio>
                                            <a-select v-if="customer_type == 'S'" mode="multiple" v-model="customer_card_type_ids" showSearch placeholder="All Customer Card Types" optionFilterProp="children" class="mt-3 ml-3" style="width: 100%" :filterOption="filterOption">
                                                <a-select-option v-for="option in customerCardTypeOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                            </a-select>
                                        </div>
                                        <div class="col-md-12">
                                            <base-checkbox class="mb-3 mt-5" v-model="promo.enable_other_customer_info" :disabled="viewOnly">
                                                    Get other Customer Information
                                            </base-checkbox>
                                        </div>
                                        <div class="col-md-12">
                                            <base-checkbox class="mb-3 mt-3" v-model="promo.is_max_discount_allowed" :disabled="viewOnly">
                                                    Apply maximum discount allowed for Employee's transaction
                                            </base-checkbox>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>

                            <div v-if="current == 3" class="card-body">
                                <fieldset :disabled="viewOnly">
                                    <h2 class="card-title">Select Payment Types</h2>
                                    <div class="row ml-3">
                                        <div class="col-md-12">
                                            <base-input alternative="" label="Select Payment Type">
                                                <a-select mode="multiple" :disabled="viewOnly" v-model="payment_type_ids" showSearch placeholder="All Payment Types" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                                    <a-select-option v-for="option in paymentTypeOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                </a-select>
                                            </base-input>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>

                            <div v-if="current == 4" class="card-body">
                                <fieldset :disabled="viewOnly">
                                    <h2 class="card-title">Select Sites</h2>
                                    <div class="row ml-3">
                                        <div class="col-md-12">
                                            <base-radio name="A" v-model="site_selection">
                                                All Sites (default)
                                            </base-radio>
                                            <br>
                                            <base-radio name="S" v-model="site_selection">
                                                Specific Site
                                            </base-radio>
                                            <!-- <a-select v-if="site_selection == 'S'" mode="multiple" v-model="site_ids" showSearch placeholder="All Sites" optionFilterProp="children" class="mt-3 ml-3" style="width: 100%" :filterOption="filterOption">
                                                <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                            </a-select> -->
                                            <!-- site products location tagging -->
                                            <div v-if="site_selection == 'S'">
                                                <br/>
                                                <div class="col-md-8">
                                                    <!--
                                                            * selected row keys accepts parents key
                                                            * parent_key change to location name which is string .
                                                            * filter selected row keys to remove string which is the parent key on create and update method
                                                            -->
                                                    <a-tree
                                                    checkable
                                                    :defaultCheckedKeys="selectedRowKeys"
                                                    :treeData="productLocationData"
                                                    :disabled="viewOnly"
                                                    @check="onCheckSiteId"
                                                    />
                                                </div>
                                            </div>
                                            <!-- end site products location tagging -->
                                        </div>
                                    </div>
                                </fieldset>
                            </div>

                            <div v-if="current == 5" class="card-body">
                                <fieldset :disabled="viewOnly">
                                    <h2 class="card-title">Select POS Transaction Types</h2>
                                    <div class="row ml-3">
                                        <div class="col-md-12">
                                            <base-input alternative="" label="Select POS Transaction Type">
                                                <a-select mode="multiple" v-model="transaction_type_ids" showSearch
                                                    placeholder="All Transaction Types" optionFilterProp="children"
                                                    style="width: 100%" :filterOption="filterOption" :disabled="viewOnly">
                                                    <a-select-option v-for="option in transactionTypeOptions" :key="option.id"
                                                        :value="option.id">{{ option.name }}</a-select-option>
                                                </a-select>
                                            </base-input>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                            <!-- visible for shakeys and peri account only -->
                            <div v-if="current == 6 && showAdditionalPromoConfig" class="card-body">
                                <fieldset :disabled="viewOnly">
                                    <h2 class="card-title">Additional Promo Configuration</h2>
                                    <div class="row ml-3">
                                        <div class="col-md-12">
                                            <div class="row ml-3">
                                                <div class="col-md-12">
                                                    <base-checkbox class="mb-3 mt-1" v-model="enable_manager_override" :disabled="viewOnly">
                                                        Require Manager Override
                                                    </base-checkbox>
                                                    <base-checkbox class="mb-3 mt-1" v-model="is_required_supercard" :disabled="viewOnly">
                                                        Require Supercard Number?
                                                    </base-checkbox>
                                                    <base-checkbox class="mb-3 mt-1" v-model="allow_government_combination" :disabled="viewOnly">
                                                        Allow Combination with Government Discount
                                                    </base-checkbox>
                                                    <base-checkbox class="mb-3 mt-1" v-model="allow_other_combination" :disabled="viewOnly">
                                                        Allow Combination with Other Discounts
                                                    </base-checkbox>
                                                    <base-checkbox class="mb-3 mt-1" v-model="allow_overall_combination" :disabled="viewOnly">
                                                        Allow Combination with Overall Discount
                                                    </base-checkbox>
                                                    <base-input label="Max Product Quantity" class="mt-1" > <br>
                                                        <a-input type="number" min="0" v-model="max_product_qty" placeholder="Enter Max Product Quantity" :disabled="viewOnly" style="width: 30%" />
                                                    </base-input>

                                                    <!-- TIER SETUP FORM -->
                                                    <base-input label="Tier Setup" class="mt-1">
                                                        <template #default>
                                                            <i 
                                                            class="fa fa-plus-circle text-green ml-2" 
                                                            style="cursor: pointer" 
                                                            @click="addRow">
                                                            </i>

                                                            <table v-if="tier_setup.length" class="miniform">
                                                                <thead>
                                                                    <tr><th>Name</th><th>Amount</th><th style="text-align: center; padding-left: 12px;" >Action</th></tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(row, idx) in tier_setup" :key="row.id">
                                                                    <td><a-input v-model="row.name" :disabled="!row.isEditing" /></td>
                                                                    <td><a-input v-model.number="row.amount" type="number" :disabled="!row.isEditing" /></td>
                                                                    <td style="padding-left: 12px;" >
                                                                        <button :class="{
                                                                            'btn btn-sm btn-success': row.isEditing,  
                                                                            'btn btn-sm btn-warning': !row.isEditing 
                                                                            }" 
                                                                            @click="toggleSave(idx)">
                                                                                {{ row.isEditing ? 'Save' : 'Edit' }}
                                                                        </button>
                                                                        <a-popconfirm
                                                                            v-if="!row.isEditing"
                                                                            title="Are you sure you want to delete this tier?"
                                                                            ok-text="Yes"
                                                                            cancel-text="No"
                                                                            @confirm="deleteRow(idx)"
                                                                            >
                                                                            <button class="btn btn-sm btn-danger">Delete</button>
                                                                        </a-popconfirm>
                                                                    </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </template>
                                                    </base-input>

                                                    <!-- FOR FREE ITEMS -->
                                                    <h3>Free Item</h3>
                                                    <div class="col-md-12">
                                                        <a-tabs default-active-key="1">
                                                            <a-tab-pane key="1">
                                                                <span slot="tab">
                                                                    <span class="numberCircle">1</span>
                                                                    Search
                                                                </span>

                                                                <div class="row no-gutters">
                                                                    <div class="col-md-12 mb-3">
                                                                        <b-input-group>
                                                                            <template v-slot:prepend>
                                                                                <b-dropdown :text="filterCaption" variant="outline-default">
                                                                                    <b-dropdown-item @click.prevent="changeFilter('name')">Name</b-dropdown-item>
                                                                                    <b-dropdown-item @click.prevent="changeFilter('barcode')">Barcode</b-dropdown-item>
                                                                                </b-dropdown>
                                                                            </template>
                                                                    
                                                                            <b-form-input style="padding:5px; height: 44px;" @keypress.enter="allProductsDataForFreeItem" v-model="searchTextForFreeItem">{{searchTextForFreeItem}}</b-form-input>
                                                                        </b-input-group>
                                                                    </div>
                                                                </div>

                                                                <div v-if="changeFreeItemDisplay == true" class="table-responsive">
                                                                    <div id="free-item-product-table" ></div>
                                                                    <VueTabulator ref="tabulator" v-model="freeItemProductData" :options="freeItemOptions" style="display:none;" :key="freeItemRefKey"/>
                                                                </div>
                                                                <div v-else class="table-responsive">
                                                                    <div id="free-item-product-table" style="display:none;"></div>
                                                                    <VueTabulator ref="tabulator" v-model="freeItemProductData" :options="freeItemOptions" :key="freeItemRefKey"/>
                                                                </div>
                                                            </a-tab-pane>
                                                            <a-tab-pane key="2">
                                                                <span slot="tab">
                                                                    <span class="numberCircle">2</span>
                                                                    Free Item List
                                                                </span>
                                                                <div class="table-responsive">
                                                                    <fieldset >
                                                                        <div v-if="showAddedProductTabulator">
                                                                            <VueTabulator
                                                                            ref="addedProductTabulator"
                                                                            v-model="selectedFreeItem"
                                                                            :options="selectedFreeItemOptions" 
                                                                            :key="freeItemRefKey"
                                                                            :integration="{ updateStrategy: 'UPDATE' }"/>
                                                                        </div>
                                                                    </fieldset>
                                                                </div>
                                                            </a-tab-pane>
                                                        </a-tabs>
                                                    </div>

                                                    <!-- BLOCKLIST PRODUCTS -->
                                                    <h3>Blocklist Item</h3>
                                                    <div class="col-md-12">
                                                        <a-tabs default-active-key="1">
                                                            <a-tab-pane key="1">
                                                                <span slot="tab">
                                                                    <span class="numberCircle">1</span>
                                                                    Search
                                                                </span>

                                                                <div class="row no-gutters">
                                                                    <div class="col-md-12 mb-3">
                                                                        <b-input-group>
                                                                            <template v-slot:prepend>
                                                                                <b-dropdown :text="filterCaption" variant="outline-default">
                                                                                    <b-dropdown-item @click.prevent="changeFilter('name')">Name</b-dropdown-item>
                                                                                    <b-dropdown-item @click.prevent="changeFilter('barcode')">Barcode</b-dropdown-item>
                                                                                </b-dropdown>
                                                                            </template>

                                                                            <b-form-input style="padding:5px; height: 44px;" @keypress.enter="allProductsDataForBlocklistItem" v-model="searchTextForBlocklistItem">{{searchTextForBlocklistItem}}</b-form-input>
                                                                        </b-input-group>
                                                                    </div>
                                                                </div>

                                                                <div v-if="changeBlocklistDisplay == true" class="table-responsive">
                                                                    <div id="blocklist-item-product-table" ></div>
                                                                    <VueTabulator ref="tabulator" v-model="blockItemProductData" :options="blocklistItemOptions" style="display:none;" :key="blocklistRefKey"/>
                                                                </div>
                                                                <div v-else class="table-responsive">
                                                                    <div id="blocklist-item-product-table" style="display:none;"></div>
                                                                    <VueTabulator ref="tabulator" v-model="blockItemProductData" :options="blocklistItemOptions" :key="blocklistRefKey"/>
                                                                </div>
                                                            </a-tab-pane>
                                                            <a-tab-pane key="2">
                                                                <span slot="tab">
                                                                    <span class="numberCircle">2</span>
                                                                    Blocklist Item List
                                                                </span>
                                                                <div class="table-responsive">
                                                                    <fieldset >
                                                                        <div v-if="showAddedProductTabulator">
                                                                            <VueTabulator
                                                                            ref="addedProductTabulator"
                                                                            v-model="selectedBlocklistItem"
                                                                            :options="selectedBlockListItemOptions" 
                                                                            :key="blocklistRefKey"
                                                                            :integration="{ updateStrategy: 'UPDATE' }"/>
                                                                        </div>
                                                                    </fieldset>
                                                                </div>
                                                            </a-tab-pane>
                                                        </a-tabs>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                    </div>
                </div>
            </div>
        </a-spin>

        <a-drawer title="ADD EXCEPTION" :width="480" placement="right" :closable="false" :visible="typeVisible" @close="onClose">
             <base-alert v-if="exceptionErrors.length" type="danger">
                <b>You have the following error(s):</b>
                <li v-for="error in exceptionErrors" :key="error">{{ error }}</li>
            </base-alert>
            <base-input label="Select Exception" >
                <select class="form-control" size="large" v-model="exceptionText">
                    <option v-for="option in exceptionOptions" v-bind:value="option.key" v-bind:key="option.key">
                        {{ option.value }}
                    </option>
                </select>
            </base-input>

             <div v-if="exceptionText == 'SP'">
                <base-input label="Select Supplier"><br>
                    <a-select v-model="exceptSupplier" showSearch placeholder="Select Supplier" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="searchSupplier">
                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                    <a-select-option v-for="option in supplierOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                    </a-select>
                </base-input>
            </div>

            <div v-else-if="exceptionText == 'BR'">
                <base-input label="Select Brand"><br>
                    <a-select v-model="exceptBrand" showSearch placeholder="Select Brand" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="searchBrand">
                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                    <a-select-option v-for="option in brandOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                    </a-select>
                </base-input>
            </div>

            <div v-else>
                <base-input label="Select Category"><br>
                    <a-cascader v-model="exceptCategory" :options="categoriesOptions" :showSearch="{filter}"
                    placeholder="All Categories" style="width: 100%" changeOnSelect />
                </base-input>
            </div>
            <div :style="{ position: 'absolute', right: 0, bottom: 0, width: '100%', borderTop: '1px solid #e9e9e9', padding: '10px 16px', background: '#fff', textAlign: 'right', zIndex: 1}">
                <a-button type="primary" @click="addException">
                    APPLY
                </a-button>
            </div>
        </a-drawer>

        <UploadProducts
            ref="uploadProductKey"
            :promotionId="profileId"
            :selectedProducts="selectedProductData"
            :visible="openUploadProductsDrawer"
            :onClose="toggleUploadProductsDrawer"
            :addProducts="addMassProducts"
            :promoType="promo.promo_type"
            :rewardType="promo.reward_type"
            :includeItem="include_item"
            :coupleType="coupleType"/>

        <div :style="{ position: 'absolute', right: 0, bottom: 0, width: '100%', borderTop: '1px solid #e9e9e9', padding: '10px 16px', background: '#fff', textAlign: 'right', zIndex: 1}">
            <a-button v-if="current == 0" type="default" @click="cancel">CANCEL</a-button>
            <a-button v-if="current > 0" type="default" @click="backPage(current)">BACK</a-button>
            <a-button v-if="!isLastStep" class="ml-3" type="primary" @click="nextPage(current)">NEXT</a-button>
            <a-button v-if="isLastStep && !viewOnly" class="ml-3" type="primary" :loading="doneLoading" @click.prevent="done">DONE</a-button>
            <a-button v-if="isLastStep && viewOnly" class="ml-3" type="primary" @click.prevent="close">CLOSE</a-button>
        </div>

        <vue-json-to-csv
          :labels="csvHeaders"
          :json-data="exportData"
          @success="clearExportJsonData"
          :csv-title="`${exportFileName}.csv`">
          <span ref="exportCsvBtn"></span>
        </vue-json-to-csv>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import secureStorage from '../../controllers/secureStorage';
    import Autocomplete from 'vuejs-auto-complete'
    import ProductAdvanceFilter from '../Products/ProductAdvanceFilter.vue'
    import { mapState, mapActions } from 'vuex'
    import moment from 'moment';
    import Tabulator from 'tabulator-tables';
    import UploadProducts from './Drawers/UploadProducts.vue';
    import VueJsonToCsv from 'vue-json-to-csv';
    import { exportProductCSV } from './Utilities/promotionExport';
    import { uploadToS3, objectToFormData } from '../../utilities';

    

    var component_x;
    const productLocationData = [];
    var table;
    export default {
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType',
                         'categoriesOptions', 'awsEndPoint']),
            // For Additional Promo Config Tab
            isLastStep() {
                return this.current === (this.showAdditionalPromoConfig ? 6 : 5);
            }
        },
        components: {
          Autocomplete,
          ProductAdvanceFilter,
          UploadProducts,
          VueJsonToCsv
        },
        mounted: async function () {
            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                this.viewOnly = true
            }
            // method to check for shakeys / peri-peri account
            this.fetchAccountsAndCheck();

            this.canUploadProduct = this.showUploadCSVButton();
            this.canExportProduct = this.showExportProductButton();

            if(this.$attrs.promoType == '1'){
                this.selectedProductOptions.columns[3].title = "PERCENT DISCOUNT"
                this.reward_type_description = "Apply an discount to an item by percentage (e.g 10%)"
            } else if(this.$attrs.promoType == '2'){
                this.selectedProductOptions.columns[3].title = "PERCENT DISCOUNT"
                this.reward_type_description = "Apply multi-level discount without conditions"
            } else if(this.$attrs.promoType == '3'){
                this.reward_type_description = "Buy quantity of item X to receive a specified quantity of the same item (e.g Buy 2 of T-Shirt, Get 1 Free)"
            } else if(this.$attrs.promoType == '4'){
                this.reward_type_description = "For quantity exceeding X, discount X"
            } else if(this.$attrs.promoType == '5'){
                this.reward_type_description = "Coupon will be printed if the customer purchases a minimum or specific quantity of items listed (e.g. Buy 2 Shirts, Get 200 Reward Points)"
            } else if(this.$attrs.promoType == '6'){
                this.reward_type_description = "Buy all item on list get item X (e.g Buy all item on the list, Get Discounted or Free Umbrella)"
            }

            // get free item product list
            this.freeItemOptions.ajaxURL = this.endPoint + 'products?all=0'
            this.freeItemOptions.ajaxConfig = {
                method:"GET",
                headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
            }
            // get blocklist item product list
            this.blocklistItemOptions.ajaxURL = this.endPoint + 'products?all=0'
            this.blocklistItemOptions.ajaxConfig = {
                method:"GET",
                headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
            }

            this.productOptions.ajaxURL = this.endPoint + 'products?all=0'
            this.productOptions.ajaxConfig = {
                method:"GET",
                headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
            }

            this.productOptionsB.ajaxURL = this.endPoint + 'products?all=0'
            this.productOptionsB.ajaxConfig = {
                method:"GET",
                headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
            }

            this.levelData = []
            this.levelDataFilter = []
            this.levelCount = 1;

            component_x = this

            let payment_types = await HTTPRequest.getRequest(component_x.endPoint + "payment_types/get_valid_payment_types", null);
            component_x.paymentTypeOptions = payment_types;
            component_x.sort(component_x.paymentTypeOptions);

            let transaction_types = await HTTPRequest.getRequest(component_x.endPoint + "pos_transaction_types", null)
            component_x.transactionTypeOptions = transaction_types.data;

            if(component_x.profileId == 0){
                let siteId = secureStorage.getItem("defaultSiteId");
                component_x.selectedRowKeys.push(siteId);
                component_x.getLocationTreeData();
            }
            // component_x.getLocationTreeData();


            if (component_x.profileId > 0){
                this.spinning = true
                var promo_data = await HTTPRequest.getRequest(component_x.endPoint + 'promotions/' + component_x.profileId, null)
                component_x.getLocationTreeData();
                component_x.productLocationData =[];
                component_x.productLocationData.children = [];
                // component_x.selectedRowKeys = [];

                if(promo_data == undefined){
                    component_x.$router.go()
                } else {
                    if(promo_data["error"] == undefined){
                        
                        // load additional promo config data
                        if (promo_data["tier_setup"]) {
                            try {
                                // const parsed = JSON.parse(promo_data["tier_setup"]);
                                const parsed = promo_data["tier_setup"];
                                this.tier_setup = parsed.map(row => ({
                                    ...row,
                                    isEditing: false
                                }));

                                // for tier_setup id to be uniquee
                                const maxId = this.tier_setup.reduce((max, item) => Math.max(max, item.id), 0);
                                this.nextId = maxId + 1;
                            } catch (e) {
                                this.tier_setup = [];
                            }
                        } else {
                            this.tier_setup = [];
                        }

                        const extras = promo_data.extras || {};

                        this.enable_manager_override = !!extras.enable_manager_override;
                        this.is_required_supercard = !!extras.is_required_supercard;
                        this.allow_government_combination = !!extras.allow_government_combination
                        this.allow_other_combination = !!extras.allow_other_combination
                        this.allow_overall_combination = !!extras.allow_overall_combination
                        this.max_product_qty = Number(extras.max_product_qty || 0);
                        this.selectedFreeItem = extras.free_items || [];
                        this.selectedBlocklistItem = extras.blocklist_items || [];

                        if(this.selectedFreeItem != null && this.selectedFreeItem != undefined && this.selectedFreeItem.length > 0) {
                            let free_item = this.selectedFreeItem
                            this.selectedFreeItem = []
                            this.selectedFreeItemData = []
                            for (let index = 0; index < free_item.length; index++) {
                                const element = free_item[index];
                                this.selectedFreeItemData.push(element.product_id)
                                this.selectedFreeItem.push({
                                    product_id: element.product_id,
                                    name: element.name,
                                    barcode: element.barcode,
                                    tier_id: element.tier_id,
                                    card_option: element.card_option,
                                })
                            }
                        }

                        if(this.selectedBlocklistItem != null && this.selectedBlocklistItem != undefined && this.selectedBlocklistItem.length > 0){
                            let blocked_item = this.selectedBlocklistItem
                            this.selectedBlocklistItem = []
                            this.selectedBlockedItemData = []
                            for (let index = 0; index < blocked_item.length; index++) {
                                const element = blocked_item[index];
                                this.selectedBlockedItemData.push(element.product_id)
                                console.log('selectedBlocklistItem', this.selectedBlocklistItem)
                                console.log('selectedBlockedItemData', this.selectedBlockedItemData)
                                this.selectedBlocklistItem.push({
                                    product_id: element.product_id,
                                    name: element.name,
                                    barcode: element.barcode,
                                })
                            }
                        }
                        
                        Object.assign(component_x.promo, promo_data)
                        if (promo_data.promo_type == null){
                            component_x.promo.promo_type = "1"
                        }

                        if (promo_data.reward_type == null){
                            component_x.promo.reward_type = "1"
                        }

                        component_x.getYData = []
                        // console.log(promo_data)

                        component_x.getYData = [];
                        component_x.promo.start_date = moment(promo_data.start_date)
                        component_x.promo.end_date = moment(promo_data.end_date)

                        let days_array = promo_data.valid_days
                        if(days_array.length > 0){
                            component_x.is_specify_date = true
                            component_x.showAdvancedInfo = true
                            component_x.valid_days = { sun: false, mon: false, tue: false,
                                wed: false, thu: false, fri: false, sat: false}

                            for (let index = 0; index < days_array.length; index++) {
                                const element = days_array[index];
                                switch(element) {
                                case 1:
                                    Object.assign(component_x.valid_days, {mon: true})
                                    break;
                                case 2:
                                    Object.assign(component_x.valid_days, {tue: true})
                                    break;
                                case 3:
                                    Object.assign(component_x.valid_days, {wed: true})
                                    break;
                                case 4:
                                    Object.assign(component_x.valid_days, {thu: true})
                                    break;
                                case 5:
                                    Object.assign(component_x.valid_days, {fri: true})
                                    break;
                                case 6:
                                    Object.assign(component_x.valid_days, {sat: true})
                                    break;
                                case 7:
                                    Object.assign(component_x.valid_days, {sun: true})
                                    break;
                                }
                            }
                        }
                        delete component_x.promo.valid_days

                        component_x.replaceDiscount(component_x.promo.reward_type)

                        if(Object.keys(promo_data.valid_times).length > 0){
                            component_x.is_specify_time = true
                            component_x.showAdvancedInfo = true
                            component_x.picker_date = {
                                valid_start_time: moment(promo_data.valid_times.valid_start_time, 'HH:mm'),
                                valid_end_time: moment(promo_data.valid_times.valid_end_time, 'HH:mm')
                            }
                        }
                        delete component_x.promo.valid_times

                        let level_assign = false
                        let coupon_assign = false
                        if(promo_data.reward_conditions.length == 1){
                            let reward_condition = promo_data.reward_conditions[0]
                            let expected_value = reward_condition.expected_value
                            if((reward_condition.condition_type == 'IA' || reward_condition.condition_type == 'IQ') && reward_condition.operation == 'GE' && promo_data.promo_type == '1'){
                                component_x.include_item = "1"
                                component_x.reward.apply_level = 'IH'
                                component_x.reward.required_value = 0
                                component_x.min_amount = expected_value
                            } else if(reward_condition.condition_type == 'SP' && reward_condition.operation == 'EQ'){
                                component_x.include_item = "2"
                                component_x.allItem.supplier_id = expected_value
                            } else if(reward_condition.condition_type == 'BR' && reward_condition.operation == 'EQ'){
                                component_x.include_item = "3"
                                component_x.allItem.brand_id = expected_value
                            } else if(reward_condition.condition_type == 'DP' || reward_condition.condition_type == 'SC' || reward_condition.condition_type == 'CA'){
                                component_x.include_item = "4"
                                component_x.inputCategory = expected_value
                            } else if(reward_condition.condition_type == 'IA' || reward_condition.condition_type == 'IQ'){
                                component_x.reward.apply_level = 'IH'
                                level_assign = true
                                component_x.reward.required_value = expected_value
                            }

                            if(component_x.promo.promo_type == '5'){

                                let coupon = reward_condition.reward_value_arr[0]
                                component_x.coupon.coupon_required = coupon.for_every
                                component_x.coupon.coupon_amount = coupon.egc_amount
                                component_x.coupon.coupon_expired = moment(coupon.coupon_expiry)
                                component_x.coupon.coupon_maximum = reward_condition.max_application

                                if (component_x.coupon.coupon_maximum > 0 && component_x.coupon.coupon_maximum != ""){
                                    component_x.is_coupon_limit_printing = true
                                    component_x.coupon.is_coupon_print_one = reward_condition.print_once
                                }

                                component_x.coupon.coupon_message = reward_condition.printtext

                                coupon_assign = true
                            } else {
                                component_x.discount = reward_condition.reward_value
                            }
                        } else {
                            promo_data.reward_conditions.forEach(condition => {
                                let expected_value = condition.expected_value
                                if((condition.condition_type == 'IA' || condition.condition_type == 'IQ') && condition.operation == 'GE' && promo_data.promo_type == '1'){
                                    // component_x.include_item = "1"
                                    component_x.reward.apply_level = 'IH'
                                    component_x.reward.required_value = 0
                                    component_x.min_amount = expected_value
                                } else if(condition.condition_type == 'SP' && condition.operation == 'EQ'){
                                    component_x.include_item = "2"
                                    component_x.allItem.supplier_id = expected_value
                                } else if(condition.condition_type == 'BR' && condition.operation == 'EQ'){
                                    component_x.include_item = "3"
                                    component_x.allItem.brand_id = expected_value
                                } else if(condition.condition_type == 'DP' || condition.condition_type == 'SC' || condition.condition_type == 'CA'){
                                    component_x.include_item = "4"
                                    component_x.inputCategory = expected_value
                                } else if(condition.condition_type == 'IA' || condition.condition_type == 'IQ'){
                                    component_x.reward.apply_level = 'IH'
                                    level_assign = true
                                    component_x.reward.required_value = expected_value
                                }
                            })
                            
                            if(component_x.promo.promo_type == "5"){
                                for (let index = 0; index < promo_data.reward_conditions.length; index++) {
                                    let reward_condition = promo_data.reward_conditions[index]
                                    let expected_value = reward_condition.expected_value

                                    if((reward_condition.condition_type == 'LN' || reward_condition.condition_type == 'IQ') && reward_condition.operation == 'GE' && expected_value == 0){
                                        component_x.include_item = "1"
                                    } else if(reward_condition.condition_type == 'SP' && reward_condition.operation == 'EQ'){
                                        component_x.include_item = "2"
                                        component_x.allItem.supplier_id = expected_value
                                    } else if(reward_condition.condition_type == 'BR' && reward_condition.operation == 'EQ'){
                                        component_x.include_item = "3"
                                        component_x.allItem.brand_id = expected_value
                                    } else if(reward_condition.condition_type == 'DP' || reward_condition.condition_type == 'SC' || reward_condition.condition_type == 'CA'){
                                        component_x.include_item = "4"
                                        component_x.inputCategory = expected_value
                                    } else if(reward_condition.condition_type == 'IA' || reward_condition.condition_type == 'IQ'){
                                        component_x.reward.apply_level = 'IH'
                                        level_assign = true
                                        component_x.reward.required_value = expected_value
                                    }

                                    if(index == 0){
                                        let coupon = reward_condition.reward_value_arr[index]
                                        component_x.coupon.coupon_required = coupon.for_every
                                        component_x.coupon.coupon_amount = coupon.egc_amount
                                        component_x.coupon.coupon_expired = moment(coupon.coupon_expiry)
                                        component_x.coupon.coupon_maximum = reward_condition.max_application

                                        if (component_x.coupon.coupon_maximum > 0 && component_x.coupon.coupon_maximum != ""){
                                            component_x.is_coupon_limit_printing = true
                                            component_x.coupon.is_coupon_print_one = reward_condition.print_once
                                        }

                                        component_x.coupon.coupon_message = reward_condition.printtext
                                    }
                                }
                            } else {
                                // component_x.discount = promo_data.reward_conditions[0].reward_value
                                // for empty reward_value
                                if (promo_data &&
                                    promo_data.reward_conditions &&
                                    promo_data.reward_conditions.length > 0 &&
                                    promo_data.reward_conditions[0].reward_value !== undefined) 
                                {
                                    component_x.discount = promo_data.reward_conditions[0].reward_value;
                                } else {
                                    component_x.discount = 0; 
                                }
                            }
                        }
                        delete component_x.promo.reward_conditions

                        if(promo_data.reward_exceptions.length > 0){
                            component_x.include_item = "5"
                            component_x.exceptData = []
                            for (let index = 0; index < promo_data.reward_exceptions.length; index++) {
                                const element = promo_data.reward_exceptions[index];

                                component_x.exceptData.push({
                                    field_text: element.field_text,
                                    field_value: element.condition_type,
                                    id_text: element.value_text,
                                    id_value: element.expected_value
                                })
                            }
                        }
                        delete component_x.promo.reward_exceptions

                        if(promo_data.reward_items != null && promo_data.reward_items != undefined &&
                           promo_data.reward_items.length > 0){
                            let reward_items = promo_data.reward_items
                            component_x.selectedProductData = []
                            component_x.selectedProd = []
                            component_x.getYData = []
                            component_x.activeProductId = 0
                            component_x.include_item = "6"
                            let assign_get_y = false

                            for (let index = 0; index < reward_items.length; index++) {
                                const element = reward_items[index];

                                let max_application = element.max_application
                                if(component_x.reward.max_application == element.max_application){
                                    max_application = ''
                                }

                                let round_to_nearest = element.round_to_nearest
                                if(component_x.reward.round_to_nearest == Number(element.round_to_nearest)){
                                    round_to_nearest = ''
                                }

                                component_x.selectedProd.push(element.product_id)
                                component_x.selectedProductData.push({
                                    product_id: element.product_id,
                                    name: element.product_name,
                                    retail_price: element.retail_price,
                                    promo_value: element.reward_value,
                                    barcode: element.expected_value,
                                    required_value: element.required_value,
                                    max_application: max_application,
                                    round_to_nearest: round_to_nearest,
                                    reference_code: element.reference_code,
                                    stock_no: element.stock_no
                                })

                                if(level_assign == false && component_x.promo.promo_type == "2" && component_x.promo.reward_type != "1"){
                                    component_x.reward.apply_level = 'IL'
                                } else if(assign_get_y == false && component_x.promo.promo_type == "3" && component_x.promo.reward_type == '2'){
                                    component_x.getYData.push({
                                        product_id: element.reward_product_id,
                                        name: element.reward_product_name,
                                        retail_price: element.reward_product_retail_price,
                                        reward_value: element.reward_value
                                    });

                                    component_x.get_y_type = element.reward_type
                                    if(element.reward_type == 'LP'){
                                        component_x.reward.get_y_lp = element.reward_value
                                        component_x.reward.get_y_lp_round = element.round_to_nearest || 0
                                    } else if(element.reward_type == 'LA') {
                                        component_x.reward.get_y_la = element.reward_value
                                    } else if(element.reward_type == 'PO') {
                                        component_x.reward.get_y_po = element.reward_value
                                    }

                                    assign_get_y = true
                                } else if(component_x.promo.promo_type == "4"){
                                    if(element.array_values != null){
                                        for (let v = 0; v < element.array_values.length; v++) {
                                            const level = element.array_values[v];
                                            component_x.levelData.push({
                                                key: this.levelCount,
                                                product_id: element.product_id,
                                                qty: level.trigger_amount,
                                                price: level.override_value,
                                                editable: true
                                            })

                                            if(this.activeProductId == 0){
                                                this.activeProductId = element.product_id
                                                this.activeProductName = element.product_name
                                            }

                                            if(this.activeProductId == element.product_id){
                                                component_x.levelDataFilter.push({
                                                    key: this.levelCount,
                                                    product_id: element.product_id,
                                                    qty: level.trigger_amount,
                                                    price: level.override_value,
                                                    editable: true
                                                })
                                            }

                                            this.levelCount = this.levelCount + 1;
                                        }
                                    }
                                } else if(coupon_assign == false && component_x.promo.promo_type == "5"){
                                    let coupon = element.array_values[index]
                                    component_x.coupon.coupon_required = coupon.for_every
                                    component_x.coupon.coupon_amount = coupon.egc_amount
                                    component_x.coupon.coupon_expired = moment(coupon.coupon_expiry)
                                    component_x.coupon.coupon_maximum = element.max_application

                                    if (component_x.coupon.coupon_maximum > 0 && component_x.coupon.coupon_maximum != ""){
                                        component_x.is_coupon_limit_printing = true
                                        component_x.coupon.is_coupon_print_one = element.print_once
                                    }

                                    component_x.coupon.coupon_message = element.printtext
                                    coupon_assign = true
                                } else if(assign_get_y == false && component_x.promo.promo_type == "6"){
                                    if(component_x.promo.reward_type == '1'){
                                        component_x.getYData.push({
                                            product_id: element.reward_product_id,
                                            name: element.reward_product_name,
                                            retail_price: element.reward_product_retail_price,
                                            reward_value: element.reward_value
                                        });
                                    } else {
                                        if(element.reward_type == 'CP'){
                                            let couple_values = element.array_values

                                            let cp1_discount_type = '';
                                            let cp1_amount = 0;
                                            let cp1_round = 0;

                                            let cp2_discount_type = '';
                                            let cp2_amount = 0;
                                            let cp2_round = 0;

                                            if(couple_values != null){
                                                if(couple_values.hasOwnProperty('higher') == true){
                                                    component_x.coupleType = '1'

                                                    cp1_discount_type = couple_values.higher.discount_type;
                                                    cp1_amount = couple_values.higher.amount;
                                                    cp1_round = couple_values.higher.round_to_nearest;

                                                    cp2_discount_type = couple_values.lower.discount_type;
                                                    cp2_amount = couple_values.lower.amount;
                                                    cp2_round = couple_values.lower.round_to_nearest;

                                                } else if(couple_values.hasOwnProperty('first') == true){
                                                    component_x.coupleType = '2';

                                                    cp1_discount_type = couple_values.first.discount_type;
                                                    cp1_amount = couple_values.first.amount;
                                                    cp1_round = couple_values.first.round_to_nearest;

                                                    cp2_discount_type = couple_values.second.discount_type;
                                                    cp2_amount = couple_values.second.amount;
                                                    cp2_round = couple_values.second.round_to_nearest;
                                                }

                                                component_x.get_x_type = cp1_discount_type
                                                if(cp1_discount_type == 'LSP'){
                                                    component_x.reward.get_x_lp = cp1_amount * 100;
                                                    component_x.reward.get_x_lp_round = cp1_round || 0;
                                                } else if(cp1_discount_type == 'LSA'){
                                                    component_x.reward.get_x_la = cp1_amount
                                                } else if(cp1_discount_type == 'NWP') {
                                                    component_x.reward.get_x_po = cp1_amount
                                                }

                                                if(cp2_discount_type == 'LSP'){
                                                    component_x.get_y_type = 'LP'
                                                    component_x.reward.get_y_lp = cp2_amount * 100;
                                                    component_x.reward.get_y_lp_round = cp2_round || 0;
                                                } else if(cp2_discount_type == 'LSA'){
                                                    component_x.get_y_type = 'LA'
                                                    component_x.reward.get_y_la = cp2_amount
                                                } else if(cp2_discount_type == 'NWP') {
                                                    component_x.get_y_type = 'PO'
                                                    component_x.reward.get_y_po = cp2_amount
                                                }
                                            }
                                        } else{
                                            if(element.array_values != null){
                                                for (let l = 0; l < element.array_values.length; l++) {
                                                    let blist = element.array_values[l]
                                                    component_x.selectedProdB.push(blist.product_id)

                                                    component_x.selectedProductDataB.push({
                                                        product_id: blist.product_id,
                                                        required_value: blist.quantity,
                                                        name: blist.name,
                                                        retail_price: blist.retail_price,
                                                        barcode: blist.barcode,
                                                        stock_no: blist.stock_no
                                                    })
                                                }
                                            }
                                        }
                                    }

                                    if(element.reward_type != 'CP'){
                                        component_x.get_y_type = element.reward_type
                                        if(element.reward_type == 'LP'){
                                            component_x.reward.get_y_lp = element.reward_value;
                                            component_x.reward.get_y_lp_round = element.round_to_nearest;
                                        } else if(element.reward_type == 'LA') {
                                            component_x.reward.get_y_la = element.reward_value;
                                        } else if(element.reward_type == 'PO') {
                                            component_x.reward.get_y_po = element.reward_value;
                                        }
                                    }

                                    assign_get_y = true
                                }
                            }
                        } else if (promo_data.promo_rewards && promo_data.promo_type == '3' && promo_data.reward_type == '2') {
                          const reward = promo_data.promo_rewards;
                          component_x.getYData.push({
                            product_id: reward.product_id,
                            name: reward.product_name,
                            retail_price: reward.product_retail_price,
                            reward_value: reward.reward_value
                          });

                          component_x.get_y_type = reward.reward_type
                          if(reward.reward_type == 'LP'){
                            component_x.reward.get_y_lp = reward.reward_value
                          } else if(reward.reward_type == 'LA') {
                            component_x.reward.get_y_la = reward.reward_value
                          } else if(reward.reward_type == 'PO') {
                            component_x.reward.get_y_po = reward.reward_value
                          }
                        } else if (promo_data.promo_rewards && promo_data.promo_type == '6' && promo_data.reward_type == '1') {
                          const reward = promo_data.promo_rewards;
                          component_x.getYData.push({
                            product_id: reward.product_id,
                            name: reward.product_name,
                            retail_price: reward.product_retail_price,
                            reward_value: reward.reward_value
                          });

                          if(reward.reward_type != 'CP'){
                            component_x.get_y_type = reward.reward_type
                            if(reward.reward_type == 'LP'){
                              component_x.reward.get_y_lp = reward.reward_value
                            } else if(reward.reward_type == 'LA') {
                              component_x.reward.get_y_la = reward.reward_value
                            } else if(reward.reward_type == 'PO') {
                              component_x.reward.get_y_po = reward.reward_value
                            }
                          }
                        } else if (promo_data.promo_rewards && promo_data.promo_type == '6' && promo_data.reward_type == '2') {
                          if(promo_data.promo_rewards.reward_type == 'CP'){
                            let couple_values = promo_data.promo_rewards.reward_value;

                            let cp1_discount_type = ''
                            let cp1_amount = 0
                            let cp1_round = 0;

                            let cp2_discount_type = ''
                            let cp2_amount = 0
                            let cp2_round = 0;

                            if(couple_values){
                              if(couple_values.hasOwnProperty('higher') == true){
                                component_x.coupleType = '1'

                                cp1_discount_type = couple_values.higher.discount_type
                                cp1_amount = couple_values.higher.amount
                                cp1_round = couple_values.higher.round_to_nearest;

                                cp2_discount_type = couple_values.lower.discount_type
                                cp2_amount = couple_values.lower.amount
                                cp2_round = couple_values.lower.round_to_nearest;

                              } else if(couple_values.hasOwnProperty('first') == true){
                                component_x.coupleType = '2'

                                cp1_discount_type = couple_values.first.discount_type
                                cp1_amount = couple_values.first.amount
                                cp1_round = couple_values.first.round_to_nearest;

                                cp2_discount_type = couple_values.second.discount_type
                                cp2_amount = couple_values.second.amount
                                cp2_round = couple_values.second.round_to_nearest;
                              }

                              component_x.get_x_type = cp1_discount_type
                              if(cp1_discount_type == 'LSP'){
                                component_x.reward.get_x_lp = cp1_amount * 100
                                component_x.reward.get_x_lp_round = cp1_round || 0;
                              } else if(cp1_discount_type == 'LSA'){
                                component_x.reward.get_x_la = cp1_amount
                              } else if(cp1_discount_type == 'NWP') {
                                component_x.reward.get_x_po = cp1_amount
                              }

                              if(cp2_discount_type == 'LSP'){
                                component_x.get_y_type = 'LP'
                                component_x.reward.get_y_lp = cp2_amount * 100
                                component_x.reward.get_y_lp_round = cp2_round || 0;
                              } else if(cp2_discount_type == 'LSA'){
                                component_x.get_y_type = 'LA'
                                component_x.reward.get_y_la = cp2_amount
                              } else if(cp2_discount_type == 'NWP') {
                                component_x.get_y_type = 'PO'
                                component_x.reward.get_y_po = cp2_amount
                              }
                            }
                          } else {
                            const promo_reward = promo_data.promo_rewards;
                            const reward_products = promo_reward.reward_products || [];

                            reward_products.map(product => {
                              component_x.selectedProdB.push(product.product_id)

                              component_x.selectedProductDataB.push({
                                  product_id: product.product_id,
                                  required_value: product.quantity,
                                  name: product.name,
                                  retail_price: product.retail_price,
                                  barcode: product.barcode,
                                  stock_no: product.stock_no
                              })
                            })

                            component_x.get_y_type = promo_reward.reward_type
                            if(promo_reward.reward_type == 'LP'){
                              component_x.reward.get_y_lp = promo_reward.reward_value
                            } else if(promo_reward.reward_type == 'LA') {
                              component_x.reward.get_y_la = promo_reward.reward_value
                            } else if(promo_reward.reward_type == 'PO') {
                              component_x.reward.get_y_po = promo_reward.reward_value
                            }
                          }
                        }


                        delete component_x.promo.reward_items

                        if(Object.keys(promo_data.customer_types).length > 0){
                            let customer_type = promo_data.customer_types
                            if(customer_type.is_exception == 0){
                                component_x.customer_type = 'M'
                                if(customer_type.operation == 'IN'){
                                    component_x.customer_type = 'S'
                                    component_x.customer_card_type_ids = customer_type.customer_card_type_ids
                                }
                            } else {
                                component_x.customer_type = 'N'
                            }
                        }
                        delete component_x.promo.customer_types

                        if(Object.keys(promo_data.payment_types).length > 0){
                            let payment_type = promo_data.payment_types
                            component_x.payment_type_ids = payment_type.payment_type_ids
                        }
                        delete component_x.promo.payment_types

                        if (Object.keys(promo_data.pos_transaction_types).length > 0) {
                            let transaction_type = promo_data.pos_transaction_types
                            component_x.transaction_type_ids = transaction_type.transaction_type_ids
                        }
                        delete component_x.promo.pos_transaction_types

                        if(Object.keys(promo_data.additional_options).length > 0){
                            let additional_options = promo_data.additional_options
                            if(additional_options.max_application == component_x.reward.max_application){
                                component_x.is_no_of_times = false
                            } else {
                                component_x.reward.max_application = additional_options.max_application
                                component_x.is_no_of_times = true
                            }

                            if(additional_options.round_to_nearest == component_x.reward.round_to_nearest){
                                component_x.is_round_result = false
                            } else {
                                component_x.is_round_result = true
                                component_x.reward.round_to_nearest = additional_options.round_to_nearest
                            }
                            component_x.reward.apply_discount = additional_options.reward_applied_to
                        }
                        delete component_x.promo.additional_options

                        component_x.selectedRowKeys = [];

                        component_x.selectedRowKeys = promo_data.site_ids

                        let sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites", null);
                        component_x.locationTreelength = sites.length
                        // console.log(component_x.selectedRowKeys.length, component_x.locationTreelength)
                        if(component_x.selectedRowKeys.length < component_x.locationTreelength){
                            component_x.site_selection = "S"
                        }

                        delete component_x.promo.site_ids

                        if (promo_data.promo_type == "1" && (promo_data.reward_type == "1" || promo_data.reward_type == "2")) {
                            let reward = await HTTPRequest.getRequest(this.endPoint.split("/api")[0] + "/api/v1/promo_rewards?promotion_id=" + component_x.profileId, null)
                            component_x.max_discount = reward.length != 0 ? reward[0].max_discount : 0
                            if (promo_data.reward_type == "1") {
                                component_x.discount = reward.length != 0 ? reward[0].reward_quantity * 100 : 0
                            }
                        }
                    } else {
                        this.errors = promo_data["error"].split(",");
                    }
                }
                this.spinning = false
            }

          this.checkImportJobs();
        },
        watch: {
            is_specify_date: function() {
                if(this.is_specify_date == false){
                    this.valid_days = { sun: true, mon: true, tue: true,
                        wed: true, thu: true, fri: true, sat: true}
                }
            },
            is_specify_time: function() {
                if(this.is_specify_time == false){
                    this.picker_date = {
                        valid_start_time: moment().startOf('day'),
                        valid_end_time: moment().endOf('day'),
                    }
                }
            },
            is_coupon_limit_printing: function(){
                if(this.is_coupon_limit_printing == false){
                    this.coupon.coupon_maximum = null
                    this.coupon.is_coupon_print_one = false
                } else {
                    if(this.coupon.coupon == ""){
                        this.coupon.coupon_maximum = 1
                    }
                }
            },
            get_y_type: function() {
                if(this.get_y_type == 'FB'){
                    this.reward.get_y_la = 0;
                    this.reward.get_y_po = 0;
                    this.reward.get_y_lp = 0;
                    this.reward.get_y_lp_round = 0;
                } else if(this.get_y_type == 'LA'){
                    this.reward.get_y_po = 0;
                    this.reward.get_y_lp = 0;
                    this.reward.get_y_lp_round = 0;
                } else if(this.get_y_type == 'PO'){
                    this.reward.get_y_la = 0;
                    this.reward.get_y_lp = 0;
                    this.reward.get_y_lp_round = 0;
                } else {
                    this.reward.get_y_la = 0;
                    this.reward.get_y_po = 0;
                }
            },
            get_x_type: function() {
                if(this.get_x_type == 'LSP'){
                    this.reward.get_x_la = 0
                    this.reward.get_x_po = 0
                } else if(this.get_x_type == 'LSA'){
                    this.reward.get_x_lp = 0
                    this.reward.get_x_po = 0
                } else {
                    this.reward.get_x_lp = 0
                    this.reward.get_x_la = 0
                }
            },
            'reward.apply_level': function(){
                if (this.reward.apply_level == 'IL'){
                    this.reward.apply_discount = "IL"
                }
            },
            promo: {
              handler(val){
                if (val.status == 'A' && this.$refs.uploadProductKey.fileList[0]) {
                  this.$refs.uploadProductKey.removeFile();
                  this.openNotificationWithIcon('error', "Upload product CSV file has been removed. You can't upload product for active promotions.")
                }
                this.canUploadProduct = this.showUploadCSVButton();
              },
              deep: true
            },
            include_item() {
                if (this.promo.promo_type == '1' && this.include_item == '6') {
                    this.canUploadProduct = this.showUploadCSVButton();
                }
            },
            'promo.display_reference_code': function() {
                if (!this.promo.display_reference_code) {
                    this.promo.require_reference_code = false
                }
            },
            'promo.require_voucher_entry': function() {
                if (!this.promo.require_voucher_entry) {
                    this.promo.check_online = false
                }
            },

            filterValue: 'updateFilter',
            filterFieldC: 'updateFilter',
        },
        data: function () {
            return {
                filterKey: 0,
                filterParams: {},
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                currentFilter: "category_id",
                massUpdateMode: false,
                parentParams: {},
                tags: [],
                advanceFilterParamsText: '',
                canUploadProduct: false,
                canExportProduct: false,
                openUploadProductsDrawer: false,
                showAddedProductTabulator: true,

                modalVisible: false,
                modalAvailableFields: false,
                confirmLoading: false,
                massDiscount: '',
                massLimit: '',
                massRound: '',
                massRequired: '',
                locationTreelength: 0,
                refKey: 0,
                blocklistRefKey: 'blocklist-' + Date.now(),
                freeItemRefKey: 'blocklist-' + Date.now(),
                keyComp: 0,
                levelData: [],
                levelDataFilter: [],
                levelColumns: [
                    {
                        title: 'FOR QTY STARTING AT',
                        dataIndex: 'qty',
                        width: '35%',
                        scopedSlots: {
                            customRender: 'qty'
                        },
                    },
                    {
                        title: 'PRICE IS',
                        dataIndex: 'price',
                        width: '35%',
                        scopedSlots: {
                            customRender: 'price'
                        },
                    },
                    {
                        title: '',
                        dataIndex: 'operation',
                        scopedSlots: {
                            customRender: 'operation'
                        },
                    }
                ],

                // item list search field
                filterCaptionC: "Search by Name",
                filterFieldC: 'name',
                filterType: 'like',
                filterValue: '',

                changeDisplayB: false,
                searchTextB:'',
                filterCaptionB: "Search by Name",
                filterFieldB: "name",

                changeDisplay: false,
                searchText:'',
                filterCaption: "Search by Name",
                filterField: "name",

                levelCount: 1,
                activeProductId: 0,
                activeProductName: "",
                coupon: {
                    coupon_required: "1",
                    coupon_amount: "100",
                    coupon_expired: moment().endOf('day'),
                    coupon_maximum: "",
                    coupon_message: "****************************************\nCongratulations!  You have won a free\ngift certificate worth {egc_amount}.\n\nThis coupon is valid until: {coupon_expiry}\n\n{coupon_barcode}\n\nNo. {site_code}-{terminal_code}-{or_no}-{seq_no}\n{date}/{time}\n****************************************\n",
                    is_coupon_print_one: false
                },
                is_coupon_limit_printing: false,
                coupon_description: "Enter quantity required to activate promo",
                spinning: false,
                promo: {
                    reward_type: '1',
                    priority: 1,
                    promo_type: this.$attrs.promoType,
                    start_date: moment().startOf('day'),
                    end_date: moment().endOf('day'),
                    status: 'A',
                    enable_other_customer_info: false,
                    is_max_discount_allowed: false,
                    display_reference_code: false,
                    require_reference_code: false,
                    require_voucher_entry: false,
                    require_supercard_number: false,
                    check_online: false,
                    is_print_approval_copy: false
                },
                reward: {
                    max_application: 1000,
                    round_to_nearest: 0,
                    apply_discount: "IL",
                    apply_level: "IL",
                    apply_header: "IL",
                    required_value: 1,
                    get_y_lp: 0,
                    get_y_lp_round: 0,
                    get_y_la: 0,
                    get_y_po: 0,
                    get_x_lp: 0,
                    get_x_lp_round: 0,
                    get_x_la: 0,
                    get_x_po: 0
                },
                get_y_type: 'LP',
                get_x_type: 'LSP',
                allItem: {
                    supplier_id: [],
                    brand_id: []
                },
                reward_type_description: "",
                picker_date: {
                    valid_start_time: moment().startOf('day'),
                    valid_end_time: moment().endOf('day'),
                },
                exceptBrand: [],
                exceptSupplier: [],
                exceptCategory: [],
                discount: "1",
                typeVisible: false,
                site_selection: 'A',
                site_ids: [],
                productLocationData: [],
                selectedRowKeys: [],
                siteOptions: [],
                customer_card_type_ids: [],
                customerCardTypeOptions: [],
                customer_type: 'A',
                is_specify_time: false,
                is_specify_date: false,
                is_no_of_times: false,
                is_round_result: false,
                valid_days: {
                    mon: true,
                    tue: true,
                    wed: true,
                    thu: true,
                    fri: true,
                    sat: true,
                    sun: true
                },
                include_item: "1",
                includeItemOptions: [
                    {key: "1", value: "All Items"},
                    {key: "2", value: "All Items from a Specific Supplier"},
                    {key: "3", value: "All Items from a Specific Brand"},
                    {key: "4", value: "All Items from a Specific Category"},
                    {key: "5", value: "All Items Except"},
                    {key: "6", value: "Select Specific Items"}
                ],
                coupleType: "",
                coupleTypeOptions: [
                    {key: "", value: " - "},
                    {key: "1", value: "Higher - Lower"},
                    {key: "2", value: "First - Second"}
                ],
                inputCategory: [],
                showAdvancedInfo: false,
                dateFormat: "MM/DD/YYYY",
                rewardTypeOptions: [
                    {key: "1", value: "Percent Discount"},
                    {key: "2", value: "Price Discount"},
                    {key: "3", value: "New Price"}
                ],
                multiLevelTypeOptions: [
                    {key: "1", value: "Discount with No Requirements (Default)"},
                    {key: "2", value: "Discount with Minimum Amount"},
                    {key: "3", value: "Discount with Required Quantity"},
                ],
                buyXOptions: [
                    {key: "1", value: "Buy X Take X"},
                    {key: "2", value: "Buy X Take Y"}
                ],
                pricingOptions: [
                    {key: "1", value: "Tiered Pricing"},
                    {key: "2", value: "Volume Pricing"},
                    {key: "3", value: "Bundle Pricing"}
                ],
                couponOptions: [
                    {key: "1", value: "Generate Coupon with Required Quantity"},
                    {key: "2", value: "Generate Coupon with Required Amount"}
                ],
                condtionalOptions: [
                    {key: "1", value: "Buy all get X"},
                    {key: "2", value: "Buy any get any"}
                ],
                exceptionText: "CA",
                exceptionOptions: [
                    {key: 'CA', value: 'Category'},
                    {key: 'SP', value: 'Supplier'},
                    {key: 'BR', value: 'Brand'}
                ],
                exceptionValue: null,
                supplierOptions: [],
                brandOptions: [],
                selectedProd: [],
                selectedProdB: [],
                productData: [],
                productDataB: [],
                freeItemOptions: {
                    height: "100%",
                    pagination:"remote",
                    paginationDataSent:{
                        "page":"page",
                        "size":"per_page"
                    },
                    paginationSize:10,
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'STOCK NO.',
                            field: 'stock_no',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: '',
                            width: "10%",
                            headerSort: false,
                            formatter: this.addFreeItemButton,
                            cellClick: this.selectFreeProductItem
                        }
                    ]
                },
                blocklistItemOptions: {
                    height: "100%",
                    pagination:"remote",
                    paginationDataSent:{
                        "page":"page",
                        "size":"per_page"
                    },
                    paginationSize:10,
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'STOCK NO.',
                            field: 'stock_no',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: '',
                            width: "10%",
                            headerSort: false,
                            formatter: this.addBlocklistItemButton,
                            cellClick: this.selectBlocklistProductItem
                        }
                    ]
                },
                productOptions: {
                    height: "100%",
                    pagination:"remote",
                    paginationDataSent:{
                        "page":"page",
                        "size":"per_page"
                    },
                    paginationSize:10,
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'STOCK NO.',
                            field: 'stock_no',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: '',
                            width: "10%",
                            headerSort: false,
                            formatter: this.addButton,
                            cellClick: this.selectProduct
                        }
                    ]
                },
                productOptionsB: {
                    height: "100%",
                    pagination:"remote",
                    paginationDataSent:{
                        "page":"page",
                        "size":"per_page"
                    },
                    paginationSize:10,
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'STOCK NO.',
                            field: 'stock_no',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: '',
                            width: "10%",
                            headerSort: false,
                            formatter: this.addButtonB,
                            cellClick: this.selectProductB
                        }
                    ]
                },
                selectedFreeItemOptions: {
                    height:"100%",
                    selectable: 1,
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"40%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'TIER',
                            field: 'tier_id',
                            width: "20%",
                            headerSort: false,
                            formatter: (cell) => {
                                const id = parseInt(cell.getValue());
                                const match = this.tier_setup.find(t => t.id === id);
                                return match ? match.name : '<span style="color: #aaa;">-- Select Tier ▼ --</span>';
                            },
                            editor: "select",
                            editable: () => !this.viewOnly,
                            editorParams: () => {
                                return {
                                    values: this.tier_setup.reduce((acc, item) => {
                                         acc[item.id] = item.name; 
                                        return acc;
                                    }, {})
                                };
                            }
                        },
                        {
                            title: 'SUPERCARD OPTION',
                            field: 'card_option',
                            width: "20%",
                            headerSort: false,
                            formatter: (cell) => {
                                const value = cell.getValue();
                                return value ? value : '<span style="color: #aaa;">-- Select Card Type ▼ --</span>';
                            },
                            editor: "select",
                            editable: () => !this.viewOnly,
                            editorParams: () => {
                                return {
                                values: this.card_options.reduce((acc, item) => {
                                    acc[item.name] = item.name; 
                                    return acc;
                                }, {})
                                };
                            }
                        },
                        
                    ]
                },
                selectedBlockListItemOptions: {
                    height:"100%",
                    selectable: 1,
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"50%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "50%",
                            headerSort: false
                        },
                    ]
                },
                schemeOptions: {
                    height:"100%",
                    selectable: 1,
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "15%",
                            headerSort: false
                        },
                        {
                            title: 'LIMIT',
                            field: 'max_application',
                            width: "15%",
                            headerSort: false,
                            editor: "input",
                            editable: (cell) => !this.viewOnly 
                        },
                        {
                            title: 'ROUND',
                            field: 'round_to_nearest',
                            width: "15%",
                            headerSort: false,
                            editor: "input",
                            editable: (cell) => !this.viewOnly 
                        },
                        {
                            formatter: this.printIcon,
                            field: 'action',
                            width: "5%",
                            headerSort: false
                        }
                    ]
                },
                couponHeaderOptions: {
                    height:"100%",
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"50%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "30%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "20%",
                            headerSort: false
                        }
                    ]
                },
                couponLineOptions: {
                    height:"100%",
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"35%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "30%",
                            headerSort: false
                        },
                        {
                            title: 'QUANTITY',
                            field: 'required_value',
                            width: "15%",
                            headerSort: false,
                            editor: "input"
                        },
                    ]
                },
                selectedProductData: [],
                selectedProductDataB: [],
                selectedProductOptions: {
                    height: "100%",
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "15%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "15%",
                            headerSort: false
                        },
                        {
                            title: 'PERCENT DISCOUNT',
                            field: 'promo_value',
                            width: "15%",
                            headerSort: false,
                            editor: "input",
                            editable: (cell) => !this.viewOnly 
                        },
                        {
                            title: 'LIMIT',
                            field: 'max_application',
                            width: "10%",
                            headerSort: false,
                            editor: "input",
                            editable: (cell) => !this.viewOnly 
                        },
                        {
                            title: 'ROUND',
                            field: 'round_to_nearest',
                            width: "10%",
                            headerSort: false,
                            editor: "input",
                            editable: (cell) => !this.viewOnly 
                        },
                        {
                            title: '',
                            field: '',
                            width: "5%",
                            headerSort: false
                        }
                    ]
                },
                selectedInlineProductOptions: {
                    height: "100%",
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false
                        },
                        {
                            title: 'Barcode',
                            field: 'barcode',
                            width: "10%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "10%",
                            headerSort: false
                        },
                        {
                            title: 'PERCENT DISCOUNT',
                            field: 'promo_value',
                            width: "10%",
                            headerSort: false,
                            editor: "input",
                            editable: (cell) => !this.viewOnly 
                        },
                        {
                            title: 'MINIMUM AMOUNT',
                            field: 'required_value',
                            width: "10%",
                            headerSort: false,
                            editor: "input",
                            editable: (cell) => !this.viewOnly 
                        },
                        {
                            title: 'LIMIT',
                            field: 'max_application',
                            width: "10%",
                            headerSort: false,
                            editor: "input",
                            editable: (cell) => !this.viewOnly 
                        },
                        {
                            title: 'ROUND',
                            field: 'round_to_nearest',
                            width: "10%",
                            headerSort: false,
                            editor: "input",
                            editable: (cell) => !this.viewOnly 
                        },
                        {
                            title: '',
                            field: '',
                            width: "5%",
                            headerSort: false
                        }
                    ]
                },
                selectedBuyXGetXProductOptions: {
                    height: "100%",
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            title: 'NAME',
                            field: 'name',
                            width: "25%",
                            headerSort: false
                        },
                        {
                            title: 'Barcode',
                            field: 'barcode',
                            width: "10%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "15%",
                            headerSort: false
                        },
                        {
                            title: 'BUY QTY',
                            field: 'required_value',
                            width: "15%",
                            headerSort: false,
                            editor: "input",
                            editable: (cell) => !this.viewOnly 
                        },
                        {
                            title: 'TAKE QTY',
                            field: 'promo_value',
                            width: "15%",
                            headerSort: false,
                            editor: "input",
                            editable: (cell) => !this.viewOnly 
                        },
                        {
                            title: 'LIMIT',
                            field: 'max_application',
                            width: "10%",
                            headerSort: false,
                            editor: "input",
                            editable: (cell) => !this.viewOnly 
                        },
                        {
                            title: 'ROUND',
                            field: 'round_to_nearest',
                            width: "5%",
                            headerSort: false,
                            editor: "input",
                            editable: (cell) => !this.viewOnly 
                        },
                        {
                            title: '',
                            field: '',
                            width: "5%",
                            headerSort: false
                        }
                    ]
                },
                selectedListBProductOptions: {
                    height: "100%",
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false
                        },
                        {
                            title: 'BARCODE',
                            field: 'barcode',
                            width: "25%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "20%",
                            headerSort: false
                        },
                        {
                            title: 'QUANTITY',
                            field: 'required_value',
                            width: "15%",
                            headerSort: false,
                            editor: "input"
                        },
                        {
                            title: '',
                            field: '',
                            width: "10%",
                            headerSort: false
                        }
                    ]
                },
                selectedBuyXGetYProductOptions: {
                    height: "100%",
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"30%",
                            headerSort: false
                        },
                        {
                            title: 'Barcode',
                            field: 'barcode',
                            width: "15%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "25%",
                            headerSort: false
                        },
                        {
                            title: 'QUANTITY',
                            field: 'required_value',
                            width: "25%",
                            headerSort: false,
                            editor: "input",
                            editable: (cell) => !this.viewOnly 
                        },
                        {
                            title: '',
                            field: '',
                            width: "5%",
                            headerSort: false
                        }
                    ]
                },
                selectedGetYProductOptions: {
                    height: "100%",
                    pagination:"local",
                    paginationSize: 10,
                    columns: [
                        {
                            title:'NAME',
                            field:'name',
                            width:"50%",
                            headerSort: false
                        },
                        {
                            title: 'RETAIL PRICE',
                            field: 'retail_price',
                            width: "50%",
                            headerSort: false
                        },
                    ]
                },
                exceptData: [],
                exceptionErrors: [],
                exceptOptions: {
                    height: "100%",
                    paginationSize: 10,
                    pagination:"local",
                    columns: [
                        {
                            title: 'EXCEPTION',
                            field: 'field_text',
                            width: "25%",
                            headerSort: false
                        },
                        {
                            title: '',
                            field: 'id_text',
                            width: "25%",
                            headerSort: false
                        },
                        {
                            title: '',
                            field: '',
                            width: "5%",
                            headerSort: false
                        },
                        {
                            title: "Actions",
                            field: "actions",
                            formatter: this.deleteButtonFormatter,
                            cellClick: (e, cell) => {
                            this.confirmDelete(cell.getRow().getData());
                            },
                            headerSort: false,
                        },
                    ]
                },
                couponAvailableFieldsData: [
                    { fields: 'terminal_id', description: "Terminal Id" },
                    { fields: 'terminal_code', description: "Terminal No." },
                    { fields: 'trans_number', description: "Transaction No." },
                    { fields: 'trans_date', description: "Transaction Date" },
                    { fields: 'trans_time', description: "Transaction Time" },
                    { fields: 'or_no', description: "Receipt No." },
                    { fields: 'site_code', description: "Site Code" },
                    { fields: 'cashier', description: "Cashier Name" },
                    { fields: 'customer_code', description: "Card No." },
                    { fields: 'customer_name', description: "Customer Name" },
                    { fields: 'amount_due', description: "Amount Due" },
                    { fields: 'reprinted', description: "If Coupon is reprinted" },
                    { fields: 'expiry_date', description: "Expiry Date of coupon" }
                ],
                couponAvailableFieldsOption:{
                    columns: [
                        {
                            title:'Field Name',
                            field:'fields',
                            width:"50%",
                            headerSort: false
                        },
                        {
                            title:'Description',
                            field:'description',
                            width:"50%",
                            headerSort: false
                        }]
                },
                authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
                searchFilter: "name",
                current: 0,
                fetching: false,
                getYData: [],
                payment_type_ids: [],
                paymentTypeOptions: [],
                transaction_type_ids: [],
                transactionTypeOptions: [],
                is_ref_code: false,
                viewOnly: false,
                errors: [],
                doneLoading:false,
                promotionId: 0,
                exportFileName: `${'Promotion'}-${moment().format('YYYYMMDDHHmmss')}`,
                csvHeaders: {},
                exportData: [],
                max_discount: 0,
                min_amount: 0,
                is_required_supercard: false,
                enable_manager_override: true,
                allow_government_combination: false,
                allow_other_combination: false,
                allow_overall_combination: false,
                card_options: [
                    {id: 0, code: 'all', name: 'All'},
                    {id: 1, code: 'classic', name: 'Classic'},
                    {id: 2, code: 'gold', name: 'Gold'},
                ],
                selectedFreeItem: [],
                selectedBlocklistItem: [],
                max_product_qty: null,
                tier_setup: [],
                selected_card_option: 'all',
                nextId: 1,
                showAdditionalPromoConfig: false,
                shakeysOrPeriAccountIds: [],
                selectedFreeItemData: [],
                selectedBlockedItemData: [],
                searchTextForBlocklistItem: '',
                searchTextForFreeItem: '',
                freeItemProductData: [],
                blockItemProductData: [],
                changeFreeItemDisplay: false,
                changeBlocklistDisplay: false
            }
        },
        methods: {
            ...mapActions(['updateCategoriesOptions']),
            moment,
            async fetchAccountsAndCheck() {
                const accountId = secureStorage.getItem("accountId");
                try {
                    const allAccounts =  await HTTPRequest.getRequest(this.endPoint + "accounts/get_valid_accounts", null);
                    const filteredAccounts = allAccounts.filter(account => {
                        const name = account.account_name.toLowerCase();
                        return name === "shakeys" || name === "periperi" || name == "irippledemo";
                    });
                    this.shakeysOrPeriAccountIds = filteredAccounts.map(acc => acc.id);

                    this.showAdditionalPromoConfig = this.shakeysOrPeriAccountIds.includes(Number(accountId)); 
                } catch (error) {
                    console.error("Failed to fetch accounts:", error);
                }
            },
            getNextId() {
                const id = this.nextId;
                this.nextId += 1; 
                return id;
            },
            // JIRAH TODO:: FOR DELETION saveTierSetup
            async saveTierSetup() {
                this.errors = [];
                const promotionPayload = {
                    tier_setup: this.tier_setup.map(r => ({
                    id: Number(r.id),
                    name: r.name,
                    amount: Number(r.amount),
                    }))
                }
               
                let tier_data =  await HTTPRequest.putRequest(this.endPoint + 'promotions/' + this.profileId + '/update_tier_setup', null, promotionPayload, 'BXI-File');
                if(tier_data == undefined){
                    component_x.$router.go()
                } else {
                    if(tier_data["error"] == undefined){
                        // alert(tier_data.message)
                    } else {
                        this.errors = tier_data["error"].split(",");
                    }
                }
            },
            async addRow() {
                this.tier_setup.push({
                    id: this.getNextId(),  
                    name: '',
                    amount: null,
                    isEditing: true,  
                });
            },
            async toggleSave(idx) {
                this.errors = [];
                const row = this.tier_setup[idx];

                row.isEditing = !row.isEditing;

                if (!row.name || row.amount === null || row.amount === '' || row.amount === undefined || row.amount === 0) {
                    this.errors.push('Fill tier name and amount fields before saving and amount must be greater than 0.');
                    row.isEditing = true;
                    return;
                } else if (this.min_amount && row.amount < this.min_amount) {
                    this.errors.push(`Amount must be at least ${this.min_amount}.`);
                    row.isEditing = true;
                    return;
                }
                // row.isEditing = false;
                const clean = this.tier_setup.map(r => ({
                    id: r.id,
                    name: r.name,
                    amount: r.amount,
                }));

                this.$emit('update:tier_setup', clean);
            },
            // old
            // async toggleSave(idx) {
            //     this.errors = [];
            //     const row = this.tier_setup[idx];

            //     row.isEditing = !row.isEditing;

            //     if (!row.name || row.amount == null) {
            //         this.errors.push('Fill tier name and amount fields before saving.');
            //         row.isEditing = true;
            //         return; 
            //     } else {
            //         if ((this.min_amount && row.amount == 0)) {
            //             this.errors.push('Each tier amount must be greater than zero.');
            //             row.isEditing = true;
            //             return;
            //         } else if (this.min_amount && row.amount < this.min_amount) {
            //             this.errors.push('Each tier amount must be greater than or equal to the minimum amount.');
            //             row.isEditing = true;
            //             return;
            //         } 
            //     }                
            //     // row.isEditing = !row.isEditing;
            //         const clean = this.tier_setup.map(r => ({
            //             id: r.id,
            //             name: r.name,
            //             amount: r.amount,
            //     }));
            //     this.$emit('update:tier_setup', clean);
            //     await this.saveTierSetup(); 
            // },
            async deleteRow(idx) {
                this.errors = [];
                const tierIdToDelete = this.tier_setup[idx].id;

                // check if this tier is used in free_items and block them
                const isInFreeItem = Array.isArray(this.selectedFreeItem) && this.selectedFreeItem.some(item => {
                    return (item.tier_id) === (tierIdToDelete);
                });
                
                if (isInFreeItem) {
                    this.errors.push(`Tier is still being used in Free Items. Please remove the reference first.`);
                    return;
                }

                // proceed with deletion
                this.tier_setup.splice(idx, 1);
                await this.saveTierSetup(); 
            },
            validateFreeItems() {
                this.errors = [];
                const invalidItems = (this.selectedFreeItem || []).filter(item => {
                    return !item.tier_id || !item.card_option;
                });
                if (invalidItems.length > 0) {
                    this.errors.push(`Each free item must have both Tier and Card Option. ${invalidItems.length} item(s) are incomplete.`);
                    return false;
                }
                return true;
            },
            changeParams(params, actualParams, mode){
                this.tags = []
                var parametersCopy = this.parentParams
                var mergedParameters = Object.assign({}, parametersCopy, params);

                this.params = mergedParameters
                this.filterParams = actualParams
                this.massUpdateMode = mode
                const defaultFilters = ["status", "is_non_trade", "stock_status", "category_name",
                    "supplier_name", "start_date", "brand_names", "tag_names", "sub_brand_names", "product_group_names",
                    "inputCategory", "inputBrand", "inputSubBrand", "inputProductGroup", "inputSupplierType", "inputSupplier", "inputDate",
                    "statusFilter", "inputTag", "dateString", "isNonTrade", "stockStatus","inputProductSeriesName", "product_series_name", "inputProductSeriesDate", "product_series_date"]

                if(Object.keys(this.parentParams)[0] != undefined){
                    this.tags.push(Object.keys(this.parentParams)[0] + ":" + Object.values(this.parentParams)[0])
                }

                this.advanceFilterParamsText = ''
                Object.keys(params).forEach(function (key) {
                    if(!defaultFilters.includes(key)){
                        component_x.tags.push(`${key}: ${params[key]}`)
                        component_x.advanceFilterParamsText += `&${key}=${params[key]}`
                    }
                })

                if(params["status"] != undefined){
                    switch(params["status"]){
                        case "A":
                            this.tags.push("Status: Active")
                            break;
                        case "I":
                            this.tags.push("Status: Inactive")
                            break;
                        case "P":
                            this.tags.push("Status: Phased Out")
                            break;
                    }
                }

                if(params["is_non_trade"] != undefined){
                    this.tags.push("Non-trade: " + params["is_non_trade"])
                }

                if(params["stock_status"] != undefined){
                    switch(params["stock_status"]){
                        case "1":
                            this.tags.push("Stock: Out of Stock")
                            break;
                        case "2":
                            this.tags.push("Stock: On Stock")
                            break;
                        case "3":
                            this.tags.push("Stock: Negative Stock")
                            break;
                    }
                }

                if(params["category_name"] != undefined){
                    this.tags.push("Category: " + params["category_name"])
                }

                if(params["supplier_name"] != undefined){
                    this.tags.push("Supplier: " + params["supplier_name"])
                }

                if(params["start_date"] != undefined){
                    this.tags.push("Price Change Date: " + params["start_date"] + " to " + params["end_date"])
                }

                if(params["brand_names"] != undefined){
                    for(var i=0; i < params["brand_names"].length; i++){
                        this.tags.push("Brand: " + params["brand_names"][i] )
                    }
                }

                if(params["tag_names"] != undefined){
                    for(var j=0; j < params["tag_names"].length; j++){
                        this.tags.push("Tag: " + params["tag_names"][j] )
                    }
                }

                if(actualParams == null){
                    this.params = {}
                    this.parentParams = {}
                    this.tags = []
                }

                this.allProductsData()
                this.advanceFilter(false);
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            toggleUploadProductsDrawer(bool) {
              if (bool && !(this.promo.status == 'I' || (this.promo.status == 'A' && !this.promo.id))) {
                this.$notification['error']({
                  message: 'Error',
                  description: "Only Inactive Promotions are allowed to upload Products"
                });

                return;
              }

              this.openUploadProductsDrawer = bool;
            },
            showUploadCSVButton() {
              const promoType = this.promo.promo_type;
              const rewardType = this.promo.reward_type;

              return (((promoType == '1' && (rewardType == '3' || this.include_item == '6')) ||
                      ['2', '3', '4', '5', '6'].includes(promoType)) && !this.viewOnly)
            },
            showExportProductButton() {
              return (this.viewOnly && ([1,2,3,4,5,6].includes(parseInt(this.promo.promo_type))));
            },
            clearExportJsonData() {

            },
            exportProduct() {
              const promoType = parseInt(this.promo.promo_type)
              let specialData = {}

              if (promoType == 2) {
                specialData = { applyLevel: this.reward.apply_level }
              }

              if (promoType == 6) {
                specialData = { coupleType: this.coupleType }
              }


              const data = exportProductCSV(
                promoType,
                this.promo.reward_type,
                this.selectedProductData,
                this.selectedProductDataB,
                specialData
              );

              const { csvHeaders, csvData } = data;

              this.csvHeaders = csvHeaders;
              this.exportData = csvData;

              setTimeout(() => { this.$refs.exportCsvBtn.click() }, 200)
            },
            addMassProducts(products) {
              const productIds = products.map(prod => prod.product_id);
              this.selectedProductData = [...this.selectedProductData, ...products];
              this.selectedProd = [...this.selectedProd, ...productIds];
              this.allProductsData()
            },
            replaceStatus(value){
                this.keyComp++;
                this.promo.status = value;
            },
            changeFilter(value){
                this.filterField = value
                this.filterCaption = "Filter By " + _.startCase(this.filterField)
            },
            // item list search field
            setFilterField(value) {
                this.filterFieldC = value;
                this.filterCaptionC = "Filter By " + _.startCase(this.filterFieldC);
            },
            updateFilter() {
                if (this.filterFieldC && this.filterValue) {
                    this.$refs.addedProductTabulator.tabulatorInstance.setFilter(this.filterFieldC, this.filterType, this.filterValue);
                    // this.$refs.addedProductTabulator.tabulatorInstance.redraw(true);
                }
            },
            clearFilter() {
                this.filterValue = ''
                this.$refs.addedProductTabulator.tabulatorInstance.clearFilter();
            },
            //levels
            levelOnDelete(key) {
                const dataSource = [...this.levelData];
                const dataFilter = [...this.levelDataFilter];
                this.levelData = dataSource.filter(item => item.key !== key);
                this.levelDataFilter = dataFilter.filter(item => item.key !== key);
            },
            levelHandleAdd() {
                if(this.activeProductId > 0){
                    const { levelCount } = this;
                    this.levelData.push({
                        key: levelCount,
                        product_id: this.activeProductId,
                        qty: "",
                        price: ""
                    });

                    this.levelDataFilter.push({
                        key: levelCount,
                        product_id: this.activeProductId,
                        qty: "",
                        price: ""
                    });

                    this.levelEdit(levelCount);
                    this.levelCount = levelCount + 1;
                } else {
                    alert("Please click the product that you want to add level")
                }
            },
            levelEdit(key) {
                const newData = [...this.levelData];
                const newDataFilter = [...this.levelDataFilter];
                const target = newData.filter(item => key === item.key)[0];
                const targetFilter = newDataFilter.filter(item => key === item.key)[0];
                if (target) {
                    target.editable = true;
                    targetFilter.editable = true;
                    this.levelData = newData;
                    this.levelDataFilter = newDataFilter;
                }
            },
            levelHandleChangeTable(value, key, column) {
                const newData = [...this.levelData];
                const newDataFilter = [...this.levelDataFilter];
                const target = newData.filter(item => key === item.key)[0];
                const targetFilter = newDataFilter.filter(item => key === item.key)[0];
                if (target) {
                    target[column] = value;
                    targetFilter[column] = value;
                    this.levelData = newData;
                    this.levelDataFilter = newDataFilter;
                }
            },
            //end levels

            getProduct: async function(group) {
                let searchProduct = group.selectedObject;
                this.getYData = []
                this.getYData.push({
                    product_id: searchProduct.id,
                    name: searchProduct.name,
                    retail_price: searchProduct.retail_price,
                    reward_value: 1
                });
            },
            printIcon(cell, formatterParams){
                return "<i class='fas fa-angle-right'></i>";
            },
            setActiveProductId(e, row){
                let product_id = row.getData().product_id
                let name = row.getData().name
                this.activeProductId = product_id
                this.activeProductName = name

                const newData = [...this.levelData];
                this.levelDataFilter = newData.filter(item => item.product_id === product_id);
            },
            productsEndpoint(input) {
                return this.endPoint + 'products?all=0&' + this.searchFilter + '=' + input
            },
            allProductsData(){
                this.changeDisplay = true
                this.productOptions.ajaxURL = this.endPoint + 'products?all=0&' + this.filterField + '=' + this.searchText + this.advanceFilterParamsText
                this.productOptions.ajaxConfig = {
                    method:"GET",
                    headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
                }

                table = new Tabulator("#product-table", this.productOptions);
            },
            allProductsDataB(){
                this.changeDisplayB = true
                this.productOptionsB.ajaxURL = this.endPoint + 'products?all=0&' + this.filterFieldB + '=' + this.searchTextB + this.advanceFilterParamsText
                this.productOptionsB.ajaxConfig = {
                    method:"GET",
                    headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
                }

                table = new Tabulator("#product-tableB", this.productOptionsB);
            },
            allProductsDataForFreeItem(){
                this.changeFreeItemDisplay = true
                this.freeItemOptions.ajaxURL = this.endPoint + 'products?all=0&' + this.filterField + '=' + this.searchTextForFreeItem
                this.freeItemOptions.ajaxConfig = {
                    method:"GET",
                    headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
                }
                table = new Tabulator("#free-item-product-table", this.freeItemOptions);
            },
            allProductsDataForBlocklistItem(){
                this.changeBlocklistDisplay = true
                this.blocklistItemOptions.ajaxURL = this.endPoint + 'products?all=0&' + this.filterField + '=' + this.searchTextForBlocklistItem
                this.blocklistItemOptions.ajaxConfig = {
                    method:"GET",
                    headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
                }
                table = new Tabulator("#blocklist-item-product-table", this.blocklistItemOptions);
            },
            formattedDisplay(result) {
                if(this.searchFilter == 'barcode'){
                    return result.barcode
                } else if(this.searchFilter == 'stock_no'){
                    return result.stock_no
                } else if(this.searchFilter == 'reference_code'){
                    return result.reference_code
                } else {
                    return result.name
                }
            },
            // Show available fields
             showAvailableFields() {
                this.modalAvailableFields = true;
            },
            // Advanced Info
            showAdvancedInfoDiv(){
                this.showAdvancedInfo ? this.showAdvancedInfo = false : this.showAdvancedInfo = true
            },
            massAssign() {
                this.modalVisible = true;
            },
            addAll: async function (){
                this.spinning = true
                this.showAddedProductTabulator = false;

                let all_products = await HTTPRequest.getRequest(component_x.endPoint + 'products?all=0&' + this.filterField + '=' + this.searchText + this.advanceFilterParamsText, null);
                let last_page = all_products.last_page
                if(all_products.last_page == 1){
                  let array = all_products.data
                  for (let index = 0; index < array.length; index++) {
                    const element = array[index];
                    if (this.selectedProd.includes(element.id) == false){
                      this.selectedProd.push(element.id)

                      this.selectedProductData.push({
                        product_id: element.id,
                        required_value: 1,
                        name: element.name,
                        retail_price: element.retail_price,
                        barcode: element.barcode,
                        stock_no: element.stock_no
                      })
                    }
                  }

                  this.allProductsData()
                } else if(all_products.last_page > 1){
                  let array = all_products.data
                  for (let index = 0; index < array.length; index++) {
                    const element = array[index];
                    if (this.selectedProd.includes(element.id) == false){
                      this.selectedProd.push(element.id)

                      this.selectedProductData.push({
                        product_id: element.id,
                        required_value: 1,
                        name: element.name,
                        retail_price: element.retail_price,
                        barcode: element.barcode,
                        stock_no: element.stock_no
                      })
                    }
                  }

                  for (let i = 2; i < all_products.last_page + 1; i++) {
                    let loop_products = await HTTPRequest.getRequest(component_x.endPoint + 'products?all=0&page=' + i + this.filterField + '=' + this.searchText + this.advanceFilterParamsText, null);
                    let array = loop_products.data
                    for (let index = 0; index < array.length; index++) {
                      const element = array[index];
                      if (this.selectedProd.includes(element.id) == false){
                        this.selectedProd.push(element.id)

                        this.selectedProductData.push({
                          product_id: element.id,
                          required_value: 1,
                          name: element.name,
                          retail_price: element.retail_price,
                          barcode: element.barcode,
                          stock_no: element.stock_no
                        })
                      }
                    }
                  }
                  this.allProductsData()
                }
                this.spinning = false;

                setTimeout(() => { this.showAddedProductTabulator = true; }, 200)
            },
            handleOk(e) {
                this.confirmLoading = true;

                for (let s = 0; s < this.selectedProductData.length; s++) {
                    if(this.massDiscount != ''){
                        this.selectedProductData[s].promo_value = this.massDiscount
                    }

                    if(this.massLimit != ''){
                        this.selectedProductData[s].max_application = this.massLimit
                    }

                    if(this.massRound != ''){
                        this.selectedProductData[s].round_to_nearest = this.massRound
                    }

                    if(this.massRequired != ''){
                        this.selectedProductData[s].required_value = this.massRequired
                    }
                }

                this.refKey++

                this.modalVisible = false;
                this.confirmLoading = false;
            },
            handleCancel(e) {
                this.modalVisible = false;
                this.modalAvailableFields = false;
            },
            addButton(cell, formatterParams){
              if (this.viewOnly) { return null; }

              let product_id = cell.getRow().getData().id

              let button = ""
              if (this.selectedProd.includes(product_id) == false){
                button = '<button id="add_' + product_id + '" class="btn btn-sm btn-success" >ADD</button>';
              } else {
                button = '<button id="add_' + product_id + '" class="btn btn-sm btn-default">UNDO</button>';
              }
              return button
            },
            addButtonB(cell, formatterParams){
              if (this.viewOnly) { return null; }

              let product_id = cell.getRow().getData().id

              let button = ""
              if (this.selectedProdB.includes(product_id) == false){
                button = '<button id="addB_' + product_id + '" class="btn btn-sm btn-success" >ADD</button>';
              } else {
                button = '<button id="addB_' + product_id + '" class="btn btn-sm btn-default">UNDO</button>';
              }
              return button
            },
            addFreeItemButton(cell, formatterParams){
              if (this.viewOnly) { return null; }
              let product_id = cell.getRow().getData().id
              let button = ""
              if (this.selectedFreeItemData.includes(product_id) == false){
                button = '<button id="add_' + product_id + '" class="btn btn-sm btn-success" >ADD</button>';
              } else {
                button = '<button id="add_' + product_id + '" class="btn btn-sm btn-default">REMOVE</button>';
              }
              return button
            },
            // JIRAH TODO: REVISIT THIS
            addBlocklistItemButton(cell, formatterParams){
                if (this.viewOnly) { return null; }
                const product_id = cell.getRow().getData().id;
                const button_id = `block_add_${product_id}`; 
                let button = '';
                if (!this.selectedBlockedItemData.includes(product_id)) {
                    button = `<button id="${button_id}" class="btn btn-sm btn-success">ADD</button>`;
                } else {
                    button = `<button id="${button_id}" class="btn btn-sm btn-default">REMOVE</button>`;
                }
                return button;
            },
            addException(){
                this.exceptionErrors = [];
                let exception_type_text = this.exceptionOptions.find(x => x.key === this.exceptionText).value
                let exception_type_value = this.exceptionText

                let excepted_text = ""
                let excepted_value = 0
                if(this.exceptionText == 'BR'){
                    excepted_text = this.brandOptions.find(x => x.id === this.exceptBrand).name
                    excepted_value = this.exceptBrand
                } else if(this.exceptionText == 'SP'){
                    excepted_text = this.supplierOptions.find(x => x.id === this.exceptSupplier).name
                    excepted_value = this.exceptSupplier
                } else {
                    if(this.exceptCategory.length > 0){
                        let resultLength = this.exceptCategory.length
                        let divisions = this.categoriesOptions.find(x => x.value === this.exceptCategory[0]).children

                        let departments = []
                        let sections = []
                        let categories = []
                        switch(resultLength) {
                        case 5:
                            departments = divisions.find(x => x.value === this.exceptCategory[1]).children
                            sections = departments.find(x => x.value === this.exceptCategory[2]).children
                            categories = sections.find(x => x.value === this.exceptCategory[3]).children
                            excepted_text = categories.find(x => x.value === this.exceptCategory[4]).label
                            exception_type_text = 'Category'
                            exception_type_value = 'CA'
                            excepted_value = this.exceptCategory[4];
                            break;
                        case 4:
                            departments = divisions.find(x => x.value === this.exceptCategory[1]).children
                            sections = departments.find(x => x.value === this.exceptCategory[2]).children
                            excepted_text = sections.find(x => x.value === this.exceptCategory[3]).label
                            exception_type_text = 'Section'
                            exception_type_value = 'SC'
                            excepted_value = this.exceptCategory[3];
                            break;
                        case 3:
                            departments = divisions.find(x => x.value === this.exceptCategory[1]).children
                            excepted_text = departments.find(x => x.value === this.exceptCategory[2]).label
                            exception_type_text = 'Department'
                            exception_type_value = 'DP'
                            excepted_value = this.exceptCategory[2];
                            break;
                        case 2:
                            alert("Select atleast in department level")
                            break;
                        }
                    }
                }

                if(excepted_value != 0 && excepted_text != ""){
                    // check if item already exist from exceptData before adding
                    let exists = this.exceptData.some(item => item.id_value == excepted_value);
                    if (!exists) {
                        this.exceptData.push({
                            field_text: exception_type_text,
                            field_value: exception_type_value,
                            id_text: excepted_text,
                            id_value: excepted_value
                        })
                    } else {
                        // notify item already exist
                        this.exceptionErrors.push('Item already exist.')
                    }
                }
            },
            selectFreeProductItem(e, cell){
                this.errors = [];
                if (e.target.id == '') { return; }
                this.showAddedProductTabulator = false;
                let button = document.getElementById(e.target.id);
                let product_id = cell.getRow().getData().id;
                if (this.selectedFreeItemData.includes(product_id) == false) {
                   if(this.selectedBlockedItemData.includes(product_id) == false) {
                     this.selectedFreeItemData.push(product_id)
                     this.selectedFreeItem.push({
                      product_id: product_id,
                      name: cell.getRow().getData().name,
                      barcode: cell.getRow().getData().barcode
                    })
                    button.className = "btn btn-sm btn-default"
                    button.innerHTML = "REMOVE"
                   } else {
                    this.errors.push('Product is already listed on the block item list');
                   }
                } else {
                    const index = this.selectedFreeItemData.indexOf(product_id);
                    const dataSource = [...this.selectedFreeItem];
                    this.selectedFreeItem = dataSource.filter(item => item.product_id !== product_id);
                    if (index > -1) {
                        this.selectedFreeItemData.splice(index, 1);
                        button.className = "btn btn-sm btn-success"
                        button.innerHTML = "ADD"
                    }
                }
                setTimeout(() => { this.showAddedProductTabulator = true; }, 300);
            },
            selectBlocklistProductItem(e, cell){
                this.errors = [];
                if (e.target.id == '') { return; }
                this.showAddedProductTabulator = false;
                let button = document.getElementById(e.target.id);
                let product_id = Number(cell.getRow().getData().id); 

                if (this.selectedBlockedItemData.includes(product_id) == false) {
                    if(this.selectedFreeItemData.includes(product_id) == false) {
                        this.selectedBlockedItemData.push(product_id)
                        this.selectedBlocklistItem.push({
                        product_id: product_id,
                        name: cell.getRow().getData().name,
                        barcode: cell.getRow().getData().barcode,
                        //   retail_price: cell.getRow().getData().retail_price,
                    })
                    button.className = "btn btn-sm btn-default"
                    button.innerHTML = "REMOVE"
                    } else {
                        this.errors.push('Product is already listed on the free item list.');
                    }
                } else {
                    const index = this.selectedBlockedItemData.indexOf(product_id);
                    const dataSource = [...this.selectedBlocklistItem];
                    this.selectedBlocklistItem = dataSource.filter(item => item.product_id !== product_id);
                    if (index > -1) {
                        this.selectedBlockedItemData.splice(index, 1);
                        button.className = "btn btn-sm btn-success"
                        button.innerHTML = "ADD"
                    }
                }
                setTimeout(() => { this.showAddedProductTabulator = true; }, 300);
            },
            selectProduct(e, cell){
                if (e.target.id == '') { return; }

                this.showAddedProductTabulator = false;

                let button = document.getElementById(e.target.id);
                let product_id = cell.getRow().getData().id;
                const stock_no = cell.getRow().getData().stock_no;

                if (this.selectedProd.includes(product_id) == false){
                    this.selectedProd.push(product_id)

                    let promo_value = "0.00"
                    if(this.promo.promo_type == "2" || this.promo.promo_type == "3"){
                        promo_value = "0"
                    } else {
                        if(this.reward_type == "1"){
                            promo_value = "0"
                        }
                    }

                    this.selectedProductData.push({
                      product_id: product_id,
                      name: cell.getRow().getData().name,
                      retail_price: cell.getRow().getData().retail_price,
                      promo_value: promo_value,
                      barcode: cell.getRow().getData().barcode,
                      reference_code: cell.getRow().getData().reference_code,
                      required_value: 1,
                      stock_no: stock_no
                    })

                    button.className = "btn btn-sm btn-default"
                    button.innerHTML = "UNDO"
                } else {
                    const index = this.selectedProd.indexOf(product_id);

                    const dataSource = [...this.selectedProductData];
                    this.selectedProductData = dataSource.filter(item => item.product_id !== product_id);

                    if (index > -1) {
                        this.selectedProd.splice(index, 1);

                        button.className = "btn btn-sm btn-success"
                        button.innerHTML = "ADD"
                    }
                }

                setTimeout(() => { this.showAddedProductTabulator = true; }, 300);
            },
            selectProductB(e, cell){
              if (e.target.id == '') { return; }

              let button = document.getElementById(e.target.id)
              let product_id = cell.getRow().getData().id
              const stock_no = cell.getRow().getData().stock_no;
              if (this.selectedProdB.includes(product_id) == false){
                this.selectedProdB.push(product_id)

                let promo_value = "0.00"
                if(this.promo.promo_type == "2" || this.promo.promo_type == "3"){
                  promo_value = "0"
                } else {
                  if(this.reward_type == "1"){
                    promo_value = "0"
                  }
                }

                this.selectedProductDataB.push({
                  product_id: product_id,
                  name: cell.getRow().getData().name,
                  retail_price: cell.getRow().getData().retail_price,
                  promo_value: promo_value,
                  barcode: cell.getRow().getData().barcode,
                  required_value: 1,
                  stock_no: stock_no
                })

                button.className = "btn btn-sm btn-default"
                button.innerHTML = "UNDO"
              } else {
                const index = this.selectedProdB.indexOf(product_id);

                const dataSource = [...this.selectedProductDataB];
                this.selectedProductDataB = dataSource.filter(item => item.product_id !== product_id);

                if (index > -1) {
                  this.selectedProdB.splice(index, 1);

                  button.className = "btn btn-sm btn-success"
                  button.innerHTML = "ADD"
                }
              }
            },
            openNotificationWithIcon(type, message) {
              this.$notification[type]({
                message: 'Error',
                description: message
              });
            },
            activeDateRangeError() {
              if (this.promo.status != 'A') return null;
              if (!this.promo.start_date || !this.promo.end_date) return "Promotion cannot be active outside start date - 2 days and end date.";

              const today = moment().startOf('day');
              const activeFrom = moment(this.promo.start_date).subtract(2, 'days').startOf('day');
              const activeUntil = moment(this.promo.end_date).endOf('day');

              return today.isBefore(activeFrom) || today.isAfter(activeUntil)
                ? "Promotion cannot be active outside start date - 2 days and end date."
                : null;
            },
            // checkSelectedProductValue(){
            //     if(this.promo.promo_type == '2' || (this.promo.promo_type == '1' && (this.promo.reward_type == '3' || this.include_item == '6'))){
            //         let non_zero = true
            //         for (let s = 0; s < this.selectedProductData.length; s++) {
            //             let product = this.selectedProductData[s]
            //             let promo_value = product.promo_value
            //             if(promo_value== "0" || promo_value == "0.00" || promo_value.trim() == ""){
            //                 non_zero = false
            //             }
            //         }
            //         return non_zero
            //     } else {
            //         return true
            //     }
            // },
            checkIfHasErrors(current) {
              let noError = true;
              let errorMsg = [];
                if(this.promo.name){
                    if(this.promo.name.length > 100){
                        noError=false
                        errorMsg.push('Promotion Name field should not exceed 100 characters.');
                    }
                } else {
                    noError=false
                    errorMsg.push('Promotion Name is required.');
                }
               
                if(this.promo.start_date > this.promo.end_date){
                    noError=false
                    errorMsg.push('Promotion start date must not be greater than promo end date.');
                }

                const activeDateRangeError = this.activeDateRangeError();
                if (activeDateRangeError) {
                    noError = false
                    errorMsg.push(activeDateRangeError);
                }

                if ((current + 1) == 1) { return { noError, errorMsg }; }

              if (this.promo.promo_type == '6' && this.promo.reward_type == '1') {
                if (this.promo.status == 'A' && this.selectedProductData.length > 0 &&
                    (this.getYData.length == 0 || !this.getYData[0].product_id)) {
                  noError = false;
                  errorMsg.push('Please select a reward product (Item X).');
                }
              }

              if ((this.promo.promo_type == '1' && (this.promo.reward_type == '3' || this.include_item == '6')) ||
                  (this.promo.promo_type == '2') || (this.promo.promo_type == '3') ||
                  (this.promo.promo_type == '6' && this.promo.reward_type == '1') ||
                  (this.promo.promo_type == '6' && this.promo.reward_type == '2' && [1, 2].includes(parseInt(this.coupleType)))
                ) {
                if (this.selectedProductData.length == 0 && !this.$refs.uploadProductKey.fileList[0]) {
                  noError = false;
                  errorMsg.push('Please select at least 1 product or upload a CSV file to populate the product.');
                }
              } else if (this.promo.promo_type == '6' && this.promo.reward_type == '2' && ![1, 2].includes(parseInt(this.coupleType))) {
                if (this.selectedProductData.length == 0 && !this.$refs.uploadProductKey.fileList[0]) {
                  noError = false;
                  errorMsg.push('Please select at least 1 prerequisite item or upload a CSV file to populate the product.');
                }
              }

              if (this.promo.promo_type == '2' || (this.promo.promo_type == '1' && (this.promo.reward_type == '3' || this.include_item == '6'))){
                for (let s = 0; s < this.selectedProductData.length; s++) {
                  let product = this.selectedProductData[s]
                  let promo_value = product.promo_value
                  if (parseFloat(promo_value) <= 0 || isNaN(promo_value) || promo_value.trim() == "") {
                    noError = false;
                    errorMsg.push('Please specify a valid discount value for the selected products.');
                    break;
                  }
                }
              }

              if (this.promo.promo_type == '3' && this.promo.reward_type != '1' &&
                  this.promo.status == 'A' && !this.$refs.uploadProductKey.fileList[0] &&
                  (this.getYData.length == 0 || !this.getYData[0].product_id) ) {
                noError = false;
                errorMsg.push("You can't activate this promotion without a Reward Product (Item Y). Please specify Item Y.");
              }

              return { noError, errorMsg };
            },
            async nextPage(current) {
              const { noError, errorMsg } = this.checkIfHasErrors(current);

              if(noError){
                this.current = current + 1
                this.spinning = true
                if(this.current == 1){
                  if(this.supplierOptions.length == 0){
                    let suppliers = await HTTPRequest.getRequest(this.endPoint + "/suppliers/get_valid_suppliers", null, null)
                    this.supplierOptions = suppliers
                    this.sort(this.supplierOptions);
                  }

                  if(this.brandOptions.length == 0){
                    let brands = await HTTPRequest.getRequest(this.endPoint + "/brands/get_valid_brands", null, null)
                    if(brands != null){
                      this.brandOptions = brands
                      this.sort(this.brandOptions);
                    }
                  }

                  if(this.categoriesOptions.length == 0){
                    let options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                    this.updateCategoriesOptions(options)
                  }

                } else if(this.current == 2) {
                  if(this.customerCardTypeOptions.length == 0){
                    let customer_card_types = await HTTPRequest.getRequest(this.endPoint + "customer_card_types/get_valid_customer_card_types", null);
                    this.customerCardTypeOptions = customer_card_types;
                    this.sort(this.customerCardTypeOptions)
                  }
                } else if(this.current == 3) {
                  if(this.siteOptions.length == 0){
                    let sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites", null);
                    this.siteOptions = sites;
                    this.sort(this.siteOptions)
                  }
                } else if(this.current == 4) {
                  if(this.siteOptions.length == 0){
                    let sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites", null);
                    this.siteOptions = sites;
                    this.sort(this.siteOptions)
                  }
                }
                this.spinning = false
              } else {
                errorMsg.map(error => {
                  this.openNotificationWithIcon('error', error);
                })
              }
            },
            backPage(current){
                this.current = current - 1
            },
            cancel(){
                this.$emit('closeDrawer');
            },
            close() {
                this.$emit('refreshPage', event)
            },
            async done(){
                this.doneLoading = true

                // check if tier and card option is present on the free items record
                if (!this.validateFreeItems()) {
                    this.doneLoading = false;
                    return;
                }

                // set additional config data for payload
                const extras = {
                    enable_manager_override: !!this.enable_manager_override,
                    is_required_supercard: !!this.is_required_supercard,
                    allow_government_combination: !!this.allow_government_combination,
                    allow_other_combination: !!this.allow_other_combination,
                    allow_overall_combination: !!this.allow_overall_combination,
                    max_product_qty: this.max_product_qty || 0,
                    free_items: this.selectedFreeItem || [],
                    blocklist_items: this.selectedBlocklistItem || [],
                };
                const tier_setup = this.tier_setup.map(r => ({
                        id: r.id,
                        name: r.name,
                        amount: r.amount,
                    }));

                const hasUploadingFile = this.$refs.uploadProductKey.fileList[0];
                const hasOngoingUpload = await this.checkImportJobBeforeSaving();

                if (this.promo.status != 'A' && hasUploadingFile && hasOngoingUpload) {
                  // Checker if User is uploading a file when there's an ongoing upload process
                  this.doneLoading = false;
                  return;
                } else if (this.promo.status == 'A' && hasOngoingUpload) {
                  // Checker if User will activate the promo and there's an ongoing upload process
                  this.doneLoading = false;
                  return;
                }

                let promotion_hash = {}

                let promo_sites = []

                // console.log("this is the selected rowkeys", this.selectedRowKeys)
                // console.log("this is site options", )
                if(this.site_selection == 'A'){
                    this.siteOptions.forEach((el) => {
                        promo_sites.push(el.id)
                    })
                    // console.log(promo_sites)
                } else {
                    var site_ids = this.selectedRowKeys.filter(
                        (x) => typeof x === "number"
                    );
                    promo_sites = site_ids;
                }
                // console.log(promo_sites)
                let promo_conditions = []
                let promo_rewards = []

                let product_condition = "MB"
                if(this.is_ref_code == true){
                    product_condition = "MR"
                }

                if(this.is_specify_date == true){
                    let day_arr = []
                    if(this.valid_days.mon == true){ day_arr.push("1") }
                    if(this.valid_days.tue == true){ day_arr.push("2") }
                    if(this.valid_days.wed == true){ day_arr.push("3") }
                    if(this.valid_days.thu == true){ day_arr.push("4") }
                    if(this.valid_days.fri == true){ day_arr.push("5") }
                    if(this.valid_days.sat == true){ day_arr.push("6") }
                    if(this.valid_days.sun == true){ day_arr.push("7") }

                    if(day_arr.length > 0){
                        promo_conditions.push({
                            is_exception: false,
                            condition_type: "VD",
                            operation: "EQ",
                            array_values: day_arr,
                            pair_no: 0
                        })
                    }
                }

                if(this.is_specify_time == true){
                    promo_conditions.push(
                        {
                            is_exception: false,
                            condition_type: "ST",
                            operation: "GE",
                            expected_value: this.picker_date.valid_start_time.format("HH:mm"),
                            pair_no: 0
                        },
                        {
                            is_exception: false,
                            condition_type: "BT",
                            operation: "LE",
                            expected_value: this.picker_date.valid_end_time.format("HH:mm"),
                            pair_no: 0
                        }
                    )
                }

                console.log(`promo_type: ${this.promo.promo_type}, reward_type: ${this.promo.reward_type}, include_item: ${this.include_item}`)
                console.log(`include_item: ${this.include_item}`)
                if(this.promo.promo_type == '1' && (this.promo.reward_type == '1' || this.promo.reward_type == '2') && this.include_item != 6){
                    // if(this.include_item == "1"){
                    if (this.min_amount > 0) {
                        promo_conditions.push({
                            is_exception: false,
                            condition_type: "IA",
                            operation: "GE",
                            expected_value: Number(this.min_amount),
                            pair_no: 0
                        })
                    }
                    // } else if(this.include_item == "2"){
                    if(this.include_item == "2"){
                        promo_conditions.push({
                            is_exception: false,
                            condition_type: "SP",
                            operation: "EQ",
                            expected_value: this.allItem.supplier_id,
                            pair_no: 0,
                            group_code: 'RD000'
                        })
                    } else if(this.include_item == "3"){
                        promo_conditions.push({
                            is_exception: false,
                            condition_type: "BR",
                            operation: "EQ",
                            expected_value: this.allItem.brand_id,
                            pair_no: 0,
                            group_code: 'RD000'
                        })
                    } else if(this.include_item == "4"){
                        if(this.inputCategory.length > 0){
                            let resultLength = this.inputCategory.length
                            let category_id = 0
                            let category_type = ""
                            switch(resultLength) {
                            case 5:
                                category_type = "CA"
                                category_id = this.inputCategory[4];
                                break;
                            case 4:
                                category_type = "SC"
                                category_id = this.inputCategory[3];
                                break;
                            case 3:
                                category_type = "DP"
                                category_id = this.inputCategory[2];
                                break;
                            case 2:
                                alert("Select atleast in department level")
                                return
                            }

                            promo_conditions.push({
                                is_exception: false,
                                condition_type: category_type,
                                operation: "EQ",
                                expected_value: category_id,
                                pair_no: 0,
                                group_code: 'RD000'
                            })
                        } else {
                            alert("No Category Selected")
                            return
                        }
                    } else if(this.include_item == "5"){
                        // commented out to prevent duplicate record || ticket #5164 
                        // promo_conditions.push({
                        //     is_exception: false,
                        //     condition_type: "IA",
                        //     operation: "GE",
                        //     expected_value: Number(this.min_amount),
                        //     pair_no: 0
                        // })

                        if(this.exceptData.length > 0){
                            for (let s = 0; s < this.exceptData.length; s++) {
                                let exempt = this.exceptData[s]

                                promo_conditions.push({
                                    is_exception: true,
                                    condition_type: exempt.field_value,
                                    operation: "EQ",
                                    expected_value: exempt.id_value,
                                    pair_no: 0,
                                    group_code: 'RD000'
                                })
                            }
                        }
                    } else {
                        for (let s = 0; s < this.selectedProductData.length; s++) {
                            let product = this.selectedProductData[s]

                            let max_application = product.max_application
                            let round_to_nearest = product.round_to_nearest

                            if (product.max_application == '' || product.max_application == null || product.max_application == undefined){
                                max_application = this.reward.max_application
                            }

                            if (product.round_to_nearest == '' || product.round_to_nearest == null || product.round_to_nearest == undefined){
                                round_to_nearest = this.reward.round_to_nearest
                            }

                            let product_value = product.barcode
                            if(this.is_ref_code == true){
                                product_value = product.reference_code
                            }

                            promo_conditions.push({
                                is_exception: false,
                                condition_type: product_condition,
                                operation: "EQ",
                                expected_value: product_value,
                                pair_no: s,
                                group_code: `RD00${s}`
                            })

                            promo_rewards.push({
                                max_application: max_application,
                                reward_type: "PO",
                                reward_quantity: product.promo_value,
                                round_to_nearest: round_to_nearest,
                                needs_printing: false,
                                pair_no: s
                            })
                        }
                    }

                    if (this.promo.reward_type == "1"){
                        let discount_value = 0
                        if(this.discount > 0){
                            discount_value = this.discount / 100
                        }

                        promo_rewards.push({
                            max_application: 1000,
                            max_discount: Number(this.max_discount),
                            reward_type: "LP",
                            reward_quantity: discount_value,
                            needs_printing: false,
                            pair_no: 0
                        })
                    } else if (this.promo.reward_type == "2"){
                        promo_rewards.push({
                            max_application: 1000,
                            reward_type: "LA",
                            reward_quantity: this.discount,
                            needs_printing: false,
                            pair_no: 0
                        })
                    }
                } else if (this.promo.promo_type == '4' || this.promo.promo_type == '3' || this.promo.promo_type == '2' || (this.promo.promo_type == '1' && (this.promo.reward_type == '3' || this.include_item == '6'))) {
                    if(this.promo.promo_type == '2' && this.promo.reward_type != '1'){
                        if(this.promo.reward_type == '2' && this.reward.apply_level == 'IH'){
                            promo_conditions.push({
                                is_exception: false,
                                condition_type: "IA",
                                operation: "GE",
                                expected_value: Number(this.reward.required_value),
                                pair_no: 0
                            })
                        } else if(this.promo.reward_type == '3' && this.reward.apply_level == 'IH') {
                            promo_conditions.push({
                                is_exception: false,
                                condition_type: "IQ",
                                operation: "GE",
                                expected_value: Number(this.reward.required_value),
                                pair_no: 0
                            })
                        }
                    } else if (this.promo.promo_type == '1' && this.include_item == '6') {
                        promo_conditions.push({
                            is_exception: false,
                            condition_type: "IA",
                            operation: "GE",
                            expected_value: Number(this.min_amount),
                            pair_no: 0
                        })
                    }

                    for (let s = 0; s < this.selectedProductData.length; s++) {
                        let product = this.selectedProductData[s]

                        let max_application = product.max_application
                        let round_to_nearest = product.round_to_nearest

                        if (product.max_application == '' || product.max_application == null || product.max_application == undefined){
                            max_application = this.reward.max_application
                        }

                        if (product.round_to_nearest == '' || product.round_to_nearest == null || product.round_to_nearest == undefined){
                            round_to_nearest = this.reward.round_to_nearest
                        }

                        let product_value = product.barcode
                        if(this.is_ref_code == true){
                            product_value = product.reference_code
                        }

                        promo_conditions.push({
                            is_exception: false,
                            condition_type: product_condition,
                            operation: "EQ",
                            expected_value: product_value,
                            pair_no: s,
                            group_code: `RD00${s}`
                        })

                        if(this.promo.promo_type == '2' && this.promo.reward_type != '1'){
                            if(this.promo.reward_type == '2' && this.reward.apply_level == 'IL'){
                                promo_conditions.push({
                                    is_exception: false,
                                    condition_type: "LN",
                                    operation: "GE",
                                    expected_value: Number(product.required_value),
                                    pair_no: s,
                                    group_code: `RD00${s}`
                                })
                            } else if(this.promo.reward_type == '3' && this.reward.apply_level == 'IL') {
                                promo_conditions.push({
                                    is_exception: false,
                                    condition_type: "LQ",
                                    operation: "GE",
                                    expected_value: Number(product.required_value),
                                    pair_no: s,
                                    group_code: `RD00${s}`
                                })
                            }
                        } else if(this.promo.promo_type == '3'){
                            promo_conditions.push({
                                is_exception: false,
                                condition_type: "LQ",
                                operation: "GE",
                                expected_value: Number(product.required_value),
                                pair_no: s,
                                group_code: `RD00${s}`
                            })
                        }

                        if(this.promo.promo_type == "1"){
                            if(this.promo.reward_type == "1"){
                                let discount_value = 0
                                if(product.promo_value > 0){
                                    discount_value = product.promo_value / 100
                                }

                                promo_rewards.push({
                                    max_application: max_application,
                                    max_discount: Number(this.max_discount), // add max_discount if included_item = 6
                                    reward_type: "LP",
                                    reward_quantity: discount_value,
                                    round_to_nearest: round_to_nearest,
                                    needs_printing: false,
                                    pair_no: s
                                })
                            } else if(this.promo.reward_type == "2"){
                                promo_rewards.push({
                                    max_application: max_application,
                                    reward_type: "LA",
                                    reward_quantity: product.promo_value,
                                    round_to_nearest: round_to_nearest,
                                    needs_printing: false,
                                    pair_no: s
                                })
                            } else {
                                promo_rewards.push({
                                    max_application: max_application,
                                    reward_type: "PO",
                                    reward_quantity: product.promo_value,
                                    round_to_nearest: round_to_nearest,
                                    needs_printing: false,
                                    pair_no: s
                                })
                            }
                        } else if(this.promo.promo_type == "2"){
                            let discount_array = product.promo_value.split(",")
                            for (let index = (discount_array.length - 1); index >= 0; index--) {
                                const element = discount_array[index];
                                let trim_element = Number(element.trim())
                                let discount_value = 0
                                if(trim_element > 0){
                                    discount_value = trim_element / 100
                                }

                                let reward_hash = {
                                    max_application: max_application,
                                    reward_type: "LP",
                                    reward_quantity: discount_value,
                                    round_to_nearest: round_to_nearest,
                                    needs_printing: false,
                                    pair_no: s,
                                    reward_no: index,
                                    reward_applied_to: this.reward.apply_discount
                                }

                                if(index != discount_array.length - 1){
                                    Object.assign(reward_hash, {
                                        child_no: index + 1
                                    })
                                }

                                promo_rewards.push(reward_hash)
                            }
                        } else if(this.promo.promo_type == "3"){
                            if(this.promo.reward_type == "1"){
                                promo_rewards.push({
                                    max_application: max_application,
                                    reward_type: "FB",
                                    reward_product_id: product.product_id,
                                    reward_quantity: Number(product.promo_value),
                                    round_to_nearest: round_to_nearest,
                                    needs_printing: false,
                                    pair_no: s
                                })
                            } else {
                                let get_y_promo_value = "0"
                                let yRound = round_to_nearest;
                                if(this.get_y_type == 'LP'){
                                  get_y_promo_value = Number(this.reward.get_y_lp) / 100
                                  yRound = Number(this.reward.get_y_lp_round);
                                } else if(this.get_y_type == 'LA'){
                                  get_y_promo_value = Number(this.reward.get_y_la)
                                } else if(this.get_y_type == 'PO'){
                                  get_y_promo_value = Number(this.reward.get_y_po)
                                } else {
                                  get_y_promo_value = 1
                                }

                                let y_rewards = {
                                    reward_type: this.get_y_type,
                                    reward_quantity: get_y_promo_value,
                                    max_application: max_application,
                                    round_to_nearest: yRound,
                                    needs_printing: false,
                                    pair_no: s
                                }

                                if(this.getYData.length == 1){
                                    let y_element = this.getYData[0]
                                    Object.assign(y_rewards, {
                                        reward_product_id: y_element.product_id
                                    })
                                }
                                promo_rewards.push(y_rewards)
                            }
                        } else if(this.promo.promo_type == "4"){
                            if(this.promo.reward_type == "1"){
                                let reward_value_arr = []
                                let level_data = this.levelData.filter(item => item.product_id === product.product_id)
                                for (let v = 0; v < level_data.length; v++) {
                                    reward_value_arr.push({
                                        trigger_amount: Number(level_data[v].qty),
                                        override_type: "PO",
                                        override_value: Number(level_data[v].price)
                                    })
                                }

                                promo_rewards.push({
                                    max_application: max_application,
                                    reward_type: "PG",
                                    reward_quantity: 1,
                                    array_values: reward_value_arr,
                                    round_to_nearest: round_to_nearest,
                                    needs_printing: false,
                                    pair_no: s
                                })
                            } else if(this.promo.reward_type == "2"){
                                let reward_value_arr = []
                                let level_data = this.levelData.filter(item => item.product_id === product.product_id)
                                for (let v = 0; v < level_data.length; v++) {
                                    reward_value_arr.push({
                                        trigger_amount: Number(level_data[v].qty),
                                        override_type: "PO",
                                        override_value: Number(level_data[v].price)
                                    })
                                }

                                promo_rewards.push({
                                    max_application: max_application,
                                    reward_type: "RL",
                                    reward_quantity: 1,
                                    array_values: reward_value_arr,
                                    round_to_nearest: round_to_nearest,
                                    needs_printing: false,
                                    pair_no: s
                                })
                            } else if(this.promo.reward_type == "3"){
                                let reward_value_arr = []
                                let level_data = this.levelData.filter(item => item.product_id === product.product_id)
                                for (let v = 0; v < level_data.length; v++) {
                                    reward_value_arr.push({
                                        trigger_amount: Number(level_data[v].qty),
                                        override_type: "BD",
                                        override_value: Number(level_data[v].price)
                                    })
                                }

                                promo_rewards.push({
                                    max_application: max_application,
                                    reward_type: "BD",
                                    reward_quantity: 1,
                                    array_values: reward_value_arr,
                                    round_to_nearest: round_to_nearest,
                                    needs_printing: false,
                                    pair_no: s
                                })
                            }
                        }
                    }

                    if (this.selectedProductData.length == 0) {
                      if (this.promo.promo_type == '3' && this.promo.reward_type == '2' &&
                          this.getYData.length == 1) {
                        let get_y_promo_value = "0"
                        let yRound = 0;
                        if(this.get_y_type == 'LP'){
                          get_y_promo_value = Number(this.reward.get_y_lp) / 100;
                          yRound = Number(this.reward.get_y_lp_round);
                        } else if(this.get_y_type == 'LA'){
                          get_y_promo_value = Number(this.reward.get_y_la)
                        } else if(this.get_y_type == 'PO'){
                          get_y_promo_value = Number(this.reward.get_y_po)
                        } else {
                          get_y_promo_value = 1
                        }

                        let y_element = this.getYData[0]
                        let y_rewards = {
                          reward_type: this.get_y_type,
                          reward_quantity: get_y_promo_value,
                          reward_product_id: y_element.product_id,
                          max_application: 1000,
                          round_to_nearest: yRound || 0,
                          needs_printing: false,
                          pair_no: 0
                        }

                        promo_rewards.push(y_rewards)
                      }
                    }
                }
                else if (this.promo.promo_type == '5'){
                    let condition_type = "IQ"
                    let reward_source = "IHQ"
                    let reward_applied_to = "IH"

                    if(this.promo.reward_type == '2'){
                        condition_type = "IA"
                        reward_source = "IHA"
                        reward_applied_to = "IH"
                    }

                    if(this.promo.reward_type == '1' && this.include_item == '6'){
                        if(this.reward.apply_level == 'IL') {
                            condition_type = "LQ"
                            reward_source = "ILQ"
                            reward_applied_to = "IL"
                        }
                    } // else if(this.promo.reward_type == '2' && this.include_item == '6'){
                        // if(this.reward.apply_level == 'IL') {
                            // condition_type = "LN"
                            // reward_source = "ILA"
                            // reward_applied_to = "IL"
                        // }
                    // }

                    if(this.include_item != "6"){
                        promo_conditions.push({
                            is_exception: false,
                            condition_type: condition_type,
                            operation: "GE",
                            expected_value: Number(this.coupon.coupon_required),
                            pair_no: 0
                        })
                    }

                    if(this.include_item == "1"){
                        promo_conditions.push({
                            is_exception: false,
                            condition_type: "AI",
                            operation: "EQ",
                            expected_value: "",
                            pair_no: 0
                        })
                    } else if(this.include_item == "2"){
                        promo_conditions.push({
                            is_exception: false,
                            condition_type: "SP",
                            operation: "EQ",
                            expected_value: this.allItem.supplier_id,
                            pair_no: 0,
                            group_code: 'RD000'
                        })
                    } else if(this.include_item == "3"){
                        promo_conditions.push({
                            is_exception: false,
                            condition_type: "BR",
                            operation: "EQ",
                            expected_value: this.allItem.brand_id,
                            pair_no: 0,
                            group_code: 'RD000'
                        })
                    } else if(this.include_item == "4"){
                        if(this.inputCategory.length > 0){
                            let resultLength = this.inputCategory.length
                            let category_id = 0
                            let category_type = ""
                            switch(resultLength) {
                            case 5:
                                category_type = "CA"
                                category_id = this.inputCategory[4];
                                break;
                            case 4:
                                category_type = "SC"
                                category_id = this.inputCategory[3];
                                break;
                            case 3:
                                category_type = "DP"
                                category_id = this.inputCategory[2];
                                break;
                            case 2:
                                alert("Select atleast in department level")
                                return
                            }

                            promo_conditions.push({
                                is_exception: false,
                                condition_type: category_type,
                                operation: "EQ",
                                expected_value: category_id,
                                pair_no: 0,
                                group_code: 'RD000'
                            })
                        } else {
                            alert("No Category Selected")
                            return
                        }
                    } else if(this.include_item == "5"){
                        if(this.exceptData.length > 0){
                            for (let s = 0; s < this.exceptData.length; s++) {
                                let exempt = this.exceptData[s]

                                promo_conditions.push({
                                    is_exception: true,
                                    condition_type: exempt.field_value,
                                    operation: "EQ",
                                    expected_value: exempt.id_value,
                                    pair_no: 0,
                                    group_code: 'RD000'
                                })
                            }
                        }
                    } else if(this.include_item == "6"){
                        let value_array = []
                        let product_array = []

                        if(this.reward.apply_level == 'IL' && this.promo.reward_type == '1'){
                            condition_type = product_condition //MR or MB
                        }

                        let total_items = 0

                        if(this.promo.reward_type == '1'){
                            for (let pd = 0; pd < this.selectedProductData.length; pd++){
                                let loop_prod = this.selectedProductData[pd]
                                if (Number(loop_prod.required_value) == 0){
                                    total_items += 1
                                } else {
                                    total_items += Number(loop_prod.required_value)
                                }
                                product_array.push({product_id: loop_prod.product_id, quantity: Number(loop_prod.required_value)})
                            }
                        } else {
                            for (let pd = 0; pd < this.selectedProductData.length; pd++){
                                let loop_prod = this.selectedProductData[pd]
                                total_items = Number(this.coupon.coupon_required)
                                product_array.push({product_id: loop_prod.product_id})
                            }
                        }

                        if(this.reward.apply_level == 'IL'){
                            //remove total for any products
                            total_items = ''
                        }

                        promo_conditions.push({
                            is_exception: false,
                            condition_type: condition_type,
                            operation: "GE",
                            expected_value: total_items,
                            pair_no: 0,
                            group_code: `RD000`,
                            custom_filter: [
                                {
                                    model: "product",
                                    value_array: product_array
                                }
                            ],
                        })
                    }

                    let final_max = 0
                    if(this.coupon.coupon_maximum == null || this.coupon.coupon_maximum == "0" || this.coupon.coupon_maximum == ""){
                        final_max = 1000
                    }else {
                        final_max = Number(this.coupon.coupon_maximum)
                    }

                    promo_rewards.push({
                        max_application: final_max,
                        round_to_nearest: this.reward.round_to_nearest,
                        reward_type: "CO",
                        reward_quantity: 1,
                        reward_source: reward_source,
                        reward_applied_to: reward_applied_to,
                        array_values: [
                            {
                                for_every: Number(this.coupon.coupon_required),
                                trigger_amount: 0,
                                coupon_expiry: this.coupon.coupon_expired.format("YYYY-MM-DD"),
                                egc_amount: Number(this.coupon.coupon_amount)
                            }
                        ],
                        print_once: this.coupon.is_coupon_print_one,
                        needs_printing: true,
                        promo_reward_printouts: [
                            {
                                printtext: this.coupon.coupon_message
                            }
                        ],
                        pair_no: 0
                    })
                }
                else if (this.promo.promo_type == '6'){
                    if (this.promo.reward_type == '2' && this.coupleType != ''){
                        let total_items = ''

                        let product_array = []

                        for (let pd = 0; pd < this.selectedProductData.length; pd++){
                            let loop_prod = this.selectedProductData[pd]
                            product_array.push({product_id: loop_prod.product_id, quantity: Number(loop_prod.required_value)})
                        }

                        promo_conditions.push({
                            is_exception: false,
                            condition_type: product_condition,
                            operation: "EQ",
                            expected_value: total_items,
                            pair_no: 0,
                            group_code: `RD000`,
                            custom_filter: [
                                {
                                    model: "product",
                                    value_array: product_array
                                }
                            ],
                        })

                        let max_application = 1000;
                        let round_to_nearest = 0;
                        for (let s = 0; s < this.selectedProductData.length; s++) {
                            let product = this.selectedProductData[s]

                            max_application = product.max_application
                            round_to_nearest = product.round_to_nearest

                            if (product.max_application == '' || product.max_application == null || product.max_application == undefined){
                                max_application = this.reward.max_application
                            }

                            if (product.round_to_nearest == '' || product.round_to_nearest == null || product.round_to_nearest == undefined){
                                round_to_nearest = this.reward.round_to_nearest
                            }

                            if(s == 0){
                                break;
                            }

                            // if(s == 0){
                            //     let get_x_promo_value = "0"
                            //     if(this.get_x_type == 'LSP'){
                            //         get_x_promo_value = Number(this.reward.get_x_lp) / 100
                            //     } else if(this.get_x_type == 'LSA'){
                            //         get_x_promo_value = Number(this.reward.get_x_la)
                            //     } else if(this.get_x_type == 'NWP'){
                            //         get_x_promo_value = Number(this.reward.get_x_po)
                            //     }

                            //     let get_y_promo_value = "0"
                            //     let get_y_promo_type = 'FB'
                            //     if(this.get_y_type == 'LP'){
                            //         get_y_promo_value = Number(this.reward.get_y_lp) / 100
                            //         get_y_promo_type = 'LSP'
                            //     } else if(this.get_y_type == 'LA'){
                            //         get_y_promo_value = Number(this.reward.get_y_la)
                            //         get_y_promo_type = 'LSA'
                            //     } else if(this.get_y_type == 'PO'){
                            //         get_y_promo_value = Number(this.reward.get_y_po)
                            //         get_y_promo_type = 'NWP'
                            //     } else {
                            //         get_y_promo_value = 1
                            //     }

                            //     let y_rewards = {
                            //         reward_type: 'CP',
                            //         reward_quantity: 1,
                            //         max_application: max_application,
                            //         round_to_nearest: round_to_nearest,
                            //         needs_printing: false,
                            //         pair_no: 0
                            //     }

                            //     if(this.coupleType == '1'){
                            //         Object.assign(y_rewards, {
                            //             couple_values: {
                            //                 higher: { discount_type: this.get_x_type, amount: get_x_promo_value},
                            //                 lower: { discount_type: get_y_promo_type, amount: get_y_promo_value}
                            //             }
                            //         })
                            //     } else {
                            //         Object.assign(y_rewards, {
                            //             couple_values: {
                            //                 first: { discount_type: this.get_x_type, amount: get_x_promo_value},
                            //                 second: { discount_type: get_y_promo_type, amount: get_y_promo_value}
                            //             }
                            //         })
                            //     }

                            //     promo_rewards.push(y_rewards)
                            //     break
                            // }
                        }

                        let get_x_promo_value = "0"
                        let xRound = null;
                        if(this.get_x_type == 'LSP'){
                            get_x_promo_value = Number(this.reward.get_x_lp) / 100
                            xRound = Number(this.reward.get_x_lp_round);
                        } else if(this.get_x_type == 'LSA'){
                            get_x_promo_value = Number(this.reward.get_x_la)
                        } else if(this.get_x_type == 'NWP'){
                            get_x_promo_value = Number(this.reward.get_x_po)
                        }

                        let get_y_promo_value = "0"
                        let get_y_promo_type = 'FB'
                        let yRound = null;
                        if(this.get_y_type == 'LP'){
                            get_y_promo_value = Number(this.reward.get_y_lp) / 100
                            yRound = Number(this.reward.get_y_lp_round);
                            get_y_promo_type = 'LSP'
                        } else if(this.get_y_type == 'LA'){
                            get_y_promo_value = Number(this.reward.get_y_la)
                            get_y_promo_type = 'LSA'
                        } else if(this.get_y_type == 'PO'){
                            get_y_promo_value = Number(this.reward.get_y_po)
                            get_y_promo_type = 'NWP'
                        } else {
                            get_y_promo_value = 1
                        }

                        let y_rewards = {
                            reward_type: 'CP',
                            reward_quantity: 1,
                            max_application: max_application,
                            round_to_nearest: round_to_nearest,
                            needs_printing: false,
                            pair_no: 0
                        }

                        if(this.coupleType == '1'){
                            let higher = { discount_type: this.get_x_type, amount: get_x_promo_value};
                            let lower = { discount_type: get_y_promo_type, amount: get_y_promo_value};
                            if (this.get_x_type == 'LSP') { higher.round_to_nearest = xRound }
                            if (this.get_y_type == 'LP') { lower.round_to_nearest = yRound }
                            y_rewards = {...y_rewards, couple_values: { higher, lower }}
                        } else {
                            let first = { discount_type: this.get_x_type, amount: get_x_promo_value};
                            let second = { discount_type: get_y_promo_type, amount: get_y_promo_value};
                            if (this.get_x_type == 'LSP') { first.round_to_nearest = xRound }
                            if (this.get_y_type == 'LP') { second.round_to_nearest = yRound }
                            y_rewards = {...y_rewards, couple_values: { first, second }}
                        }

                        promo_rewards.push(y_rewards)

                    } else {
                        let total_items = 0
                        let product_array = []

                        for (let pd = 0; pd < this.selectedProductData.length; pd++){
                            let loop_prod = this.selectedProductData[pd]
                            if (Number(loop_prod.required_value) == 0){
                                total_items += 1
                            } else {
                                total_items += Number(loop_prod.required_value)
                            }
                            product_array.push({product_id: loop_prod.product_id, quantity: Number(loop_prod.required_value)})
                        }

                        if(this.promo.reward_type == '2'){
                            //remove total for any products
                            total_items = ''
                        } else {
                            product_condition = 'IQ'
                        }

                        promo_conditions.push({
                            is_exception: false,
                            condition_type: product_condition,
                            operation: "EQ",
                            expected_value: total_items,
                            pair_no: 0,
                            group_code: `RD000`,
                            custom_filter: [
                                {
                                    model: "product",
                                    value_array: product_array
                                }
                            ],
                        })

                        let max_application = 1000;
                        let round_to_nearest = 0;
                        for (let s = 0; s < this.selectedProductData.length; s++) {
                            let product = this.selectedProductData[s]

                            max_application = product.max_application
                            round_to_nearest = product.round_to_nearest

                            if (product.max_application == '' || product.max_application == null || product.max_application == undefined){
                                max_application = this.reward.max_application
                            }

                            if (product.round_to_nearest == '' || product.round_to_nearest == null || product.round_to_nearest == undefined){
                                round_to_nearest = this.reward.round_to_nearest
                            }

                            if(s == 0){
                                // if(this.promo.reward_type == "1"){
                                //     let get_y_promo_value = "0"
                                //     if(this.get_y_type == 'LP'){
                                //         get_y_promo_value = Number(this.reward.get_y_lp) / 100
                                //     } else if(this.get_y_type == 'LA'){
                                //         get_y_promo_value = Number(this.reward.get_y_la)
                                //     } else if(this.get_y_type == 'PO'){
                                //         get_y_promo_value = Number(this.reward.get_y_po)
                                //     } else {
                                //         get_y_promo_value = 1
                                //     }

                                //     let y_rewards = {
                                //         reward_type: this.get_y_type,
                                //         reward_quantity: get_y_promo_value,
                                //         max_application: max_application,
                                //         round_to_nearest: round_to_nearest,
                                //         needs_printing: false,
                                //         pair_no: 0
                                //     }

                                //     if(this.getYData.length == 1){
                                //         let y_element = this.getYData[0]
                                //         Object.assign(y_rewards, {
                                //             reward_product_id: y_element.product_id
                                //         })
                                //     }
                                //     promo_rewards.push(y_rewards)
                                // } else {
                                //     let get_y_promo_value = "0"
                                //     if(this.get_y_type == 'LP'){
                                //         get_y_promo_value = Number(this.reward.get_y_lp) / 100
                                //     } else if(this.get_y_type == 'LA'){
                                //         get_y_promo_value = Number(this.reward.get_y_la)
                                //     } else if(this.get_y_type == 'PO'){
                                //         get_y_promo_value = Number(this.reward.get_y_po)
                                //     } else {
                                //         get_y_promo_value = 1
                                //     }

                                //     let y_rewards = {
                                //         max_application: max_application,
                                //         reward_type: this.get_y_type,
                                //         reward_quantity: get_y_promo_value,
                                //         round_to_nearest: round_to_nearest,
                                //         needs_printing: false,
                                //         pair_no: 0
                                //     }

                                //     let reward_option_array = []
                                //     for (let b = 0; b < this.selectedProductDataB.length; b++) {
                                //         let product = this.selectedProductDataB[b]

                                //         reward_option_array.push({
                                //             product_id: product.product_id,
                                //             quantity: product.required_value
                                //         })
                                //     }

                                //     Object.assign(y_rewards, {
                                //         array_values: reward_option_array,
                                //     })

                                //     promo_rewards.push(y_rewards)
                                // }
                                break
                            }
                        }

                        let yRound = 0;
                        if (this.get_y_type == 'LP') { yRound = Number(this.reward.get_y_lp_round || 0) }

                        if(this.promo.reward_type == "1"){
                          let get_y_promo_value = "0"
                          if(this.get_y_type == 'LP'){
                            get_y_promo_value = Number(this.reward.get_y_lp) / 100
                          } else if(this.get_y_type == 'LA'){
                            get_y_promo_value = Number(this.reward.get_y_la)
                          } else if(this.get_y_type == 'PO'){
                            get_y_promo_value = Number(this.reward.get_y_po)
                          } else {
                            get_y_promo_value = 1
                          }

                          let y_rewards = {
                            reward_type: this.get_y_type,
                            reward_quantity: get_y_promo_value,
                            max_application: max_application,
                            round_to_nearest: yRound || 0,
                            needs_printing: false,
                            pair_no: 0
                          }

                          if(this.getYData.length == 1){
                            let y_element = this.getYData[0]
                            Object.assign(y_rewards, {
                              reward_product_id: y_element.product_id
                            })
                          }
                          promo_rewards.push(y_rewards)
                        } else {
                          let get_y_promo_value = "0"
                          if(this.get_y_type == 'LP'){
                              get_y_promo_value = Number(this.reward.get_y_lp) / 100
                          } else if(this.get_y_type == 'LA'){
                              get_y_promo_value = Number(this.reward.get_y_la)
                          } else if(this.get_y_type == 'PO'){
                              get_y_promo_value = Number(this.reward.get_y_po)
                          } else {
                              get_y_promo_value = 1
                          }

                          let y_rewards = {
                            max_application: max_application,
                            reward_type: this.get_y_type,
                            reward_quantity: get_y_promo_value,
                            round_to_nearest: yRound || 0,
                            needs_printing: false,
                            pair_no: 0
                          }

                          let reward_option_array = []
                          for (let b = 0; b < this.selectedProductDataB.length; b++) {
                            let product = this.selectedProductDataB[b]

                            reward_option_array.push({
                              product_id: product.product_id,
                              quantity: product.required_value
                            })
                          }

                          Object.assign(y_rewards, {
                            array_values: reward_option_array,
                          })

                          promo_rewards.push(y_rewards)
                        }
                    }

                }

                if(this.customer_type == 'M'){
                    promo_conditions.push(
                        {
                            is_exception: false,
                            condition_type: "CT",
                            operation: "EX",
                            expected_value: true,
                            pair_no: 0
                        }
                    )
                } else if (this.customer_type == 'N'){
                    promo_conditions.push(
                        {
                            is_exception: true,
                            condition_type: "CT",
                            operation: "EX",
                            expected_value: true,
                            pair_no: 0
                        }
                    )
                } else if (this.customer_type == 'S'){
                    if (this.customer_card_type_ids.length > 0) {
                        promo_conditions.push(
                            {
                                is_exception: false,
                                condition_type: "CT",
                                operation: "IN",
                                array_values: this.customer_card_type_ids,
                                pair_no: 0
                            }
                        )
                    } 
                }

                if(this.payment_type_ids.length > 0){
                    promo_conditions.push({
                        is_exception: false,
                        condition_type: "PT",
                        operation: "IN",
                        array_values: this.payment_type_ids,
                        pair_no: 0
                    })
                }

                if (this.transaction_type_ids.length > 0) {
                    promo_conditions.push({
                        is_exception: false,
                        condition_type: "TT",
                        operation: "IN",
                        array_values: this.transaction_type_ids,
                        pair_no: 0
                    })
                }

                this.promo.promo_sites = promo_sites
                this.promo.promo_rewards = promo_rewards
                this.promo.promo_conditions = promo_conditions
                this.promo.extras = extras
                this.promo.tier_setup = tier_setup

                promotion_hash.promotion = this.promo;
                console.log('payload', promotion_hash.promotion)

                let form = new FormData();
                objectToFormData(form, promotion_hash);

                if (this.$refs.uploadProductKey.fileList[0] && this.canUploadProduct) {
                  const uplodingFile = this.$refs.uploadProductKey.fileList[0];
                  const accountId = secureStorage.getItem("accountId");
                  const newFileName = `${moment().format('MMDDYYhhmmss')}-${accountId}-${uplodingFile.name}`
                  const myRenamedFile = new File([uplodingFile], newFileName);

                  const fileResponse = await uploadToS3(myRenamedFile, 'promotions');

                  if (fileResponse.path) {
                    form.append('upload_product_path', fileResponse.path);
                  } else if (fileResponse.error) {
                    this.$notification['error']({
                      message: 'File Upload Failed',
                      description: fileResponse.error
                    });
                  } else {
                    this.$notification['error']({
                      message: 'File Upload Failed',
                      description: 'Please retry uploading the file or contact BXI admin.'
                    });
                  }
                }

                // form = promotion_hash

                if (!this.validateForm()) {
                    let request = []
                    if(this.profileId > 0) {
                        request = await HTTPRequest.putRequest(this.endPoint + 'promotions/' + this.profileId, null, form, "BXI-File")
                        this.create_action_history("Update")
                        //   request = await HTTPRequest.putRequest(this.endPoint + 'promotions/' + this.profileId, null, promotion_hash)
                    } else {
                        request = await HTTPRequest.postRequest(this.endPoint + 'promotions', null, form, "BXI-File")
                        this.promotionId = request.id
                        this.create_action_history("Create")
                        //   request = await HTTPRequest.postRequest(this.endPoint + 'promotions', null, promotion_hash)
                    }

                    if (request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = request["error"].split(",")
                        }
                    }
                }
                this.doneLoading = false
            },
            async create_action_history(action) {
                var id = 0
                if(this.profileId){
                    id = this.profileId
                }else {
                    id = this.promotionId
                }
                var actionHistoryPayload = {
                    action: action,
                    action_at: moment(new Date()),
                    action_by: secureStorage.getItem("userName"),
                    promotion_id: id,
                    status: "A"
                }
                await HTTPRequest.postRequest(this.endPoint + 'promotions_action_histories/', null, actionHistoryPayload, "BXI-File")
            },
            // TODO: check logic pag pabago bago ang promo type
            replaceDiscount(value){
                if(this.promo.promo_type == "2"){
                    this.selectedProductOptions.columns[3].title = "PERCENT DISCOUNT"
                    if(value == "1"){
                        this.reward_type_description = "Apply multi-level discount without conditions"
                    } else if(value == "2"){
                        this.reward_type_description = "Apply multi-level discount if the customer reaches the required minimum purchased amount"
                        this.selectedInlineProductOptions.columns[4].title = "MINIMUM AMOUNT"
                    } else {
                        this.reward_type_description = "Apply multi-level discount if the customer reaches the required minimum quantity for the item"
                        this.selectedInlineProductOptions.columns[4].title = "REQUIRED QUANTITY"
                    }
                }
                else if(this.promo.promo_type == "3"){
                    if(value == "1"){
                        this.reward_type_description = "Buy quantity of item X to receive a specified quantity of the same item (e.g Buy 2 of T-Shirt, Get 1 Free)"
                    } else {
                        this.reward_type_description = "Buy quantity of item X to item Y for new price, for a discount, or for free (Buy T-Shirt, Get Umbrella for Free)"
                    }
                } else if(this.promo.promo_type == "4"){
                    if(value == "1"){
                        this.reward_type_description = "For quantity exceeding X, discount X"
                        this.levelColumns[0].title = "FOR QTY EXCEEDING"
                        this.levelColumns[1].title = "PRICE IS"
                    } else if(value == "2"){
                        this.reward_type_description = "When quantity is greater than or equal to X, price is X"
                        this.levelColumns[0].title = "QTY IS GREATER THAN OR EQUAL TO"
                        this.levelColumns[1].title = "PRICE IS"
                    } else {
                        this.reward_type_description = "For a bundle of X, subtotal is X (e.g for every 5 items, subtotal is P20.00)"
                        this.levelColumns[0].title = "FOR A BUNDLE OF"
                        this.levelColumns[1].title = "SUBTOTAL IS"
                    }
                } else if(this.promo.promo_type == "5"){
                    if(value == "1"){
                        this.reward_type_description = "Coupon will be printed if the customer purchases a minimum or specific quantity of items listed (e.g. Buy 2 Shirts, Get 200 Reward Points)"
                        this.coupon_description = "Enter quantity required to activate promo"
                    } else {
                        this.reward_type_description = "Coupon will be printed if the transaction meets the amount criteria specified (e.g. For a minimum purchase of P2000, Get 200 Reward Points)"
                        this.coupon_description = "Enter amount required to activate promo"
                    }
                } else if(this.promo.promo_type == "6"){
                    if(value == "1"){
                        this.reward_type_description = "Buy all item on list get item X (e.g Buy all item on the list, Get Discounted or Free Umbrella)"
                    } else {
                        this.reward_type_description = "Buy any item on list get any item  (e.g Buy any item on the list, Get Discounted or Free Item on the list)"
                    }
                } else {
                    if(value == "1"){
                        this.reward_type_description = "Apply an discount to an item by percentage (e.g 10%)"
                        this.selectedProductOptions.columns[3].title = "PERCENT DISCOUNT"
                    } else if(value == '2') {
                        this.reward_type_description = "Apply an discount to an item by amount (e.g P100 off)"
                        this.selectedProductOptions.columns[3].title = "AMOUNT DISCOUNT"
                    } else {
                        this.reward_type_description = "Apply an discount to an item by giving it new price upon purchase"
                        this.selectedProductOptions.columns[3].title = "NEW PRICE"
                    }
                }

                this.refKey++
            },
            showDrawer() {
                this.typeVisible = true;
            },
            onClose() {
                this.typeVisible = false;
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            async filter(inputValue) {
                if (inputValue.length >= 3) {
                    this.categoriesOptions = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view?name=' + inputValue, null);
                }
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            async searchSupplier(value){
                this.fetching = true;

                let suppliers = await HTTPRequest.getRequest(this.endPoint + "/suppliers/get_valid_suppliers?name=" + value , null, null)
                if(suppliers != null){
                    this.supplierOptions = suppliers
                    this.sort(this.supplierOptions);
                } else {
                    this.supplierOptions = []
                }

                this.fetching = false;
            },
            async searchBrand(value){
                this.fetching = true;

                // Start
                // [Easyday Plus] Searching for brand name is not working under Promotion Management
                // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1732

                let brands = await HTTPRequest.getRequest(this.endPoint + "/brands/get_valid_brands?name=" + value , null, null)

                // [Easyday Plus] Searching for brand name is not working under Promotion Management
                // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1732
                // End

                if(brands != null){
                    this.brandOptions = brands
                    this.sort(this.brandOptions);
                } else {
                    this.brandOptions = []
                }

                this.fetching = false;
            },
            validateForm(){
                this.errors = [];
                // this.errors.push(ValidateField.required('Code', this.inputCode));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.inputCode));
                // this.errors.push(ValidateField.charMinAndMax('Code', this.inputCode, 0, 30));
                // this.errors.push(ValidateField.required('Name', this.inputName));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.inputName));
                // this.errors.push(ValidateField.charMinAndMax('Name', this.inputName, 0, 50));
                if (this.customer_type === 'S') {
                    this.errors.push(ValidateField.isEmpty("Customer Card Type", this.customer_card_type_ids));
                }
                this.errors.push(this.activeDateRangeError());
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            checkImportJobBeforeSaving: async function() {
              const importJob = await HTTPRequest.getRequest(`${this.endPoint}import_jobs?profile_name=PromotionUploadProduct-${this.profileId}`, null)
              if(!importJob || importJob.length == 0){
                return false;
              }

              const hasUploadingFile = this.$refs.uploadProductKey.fileList[0];

              const errMsg = hasUploadingFile ? "Can't upload another file when there's an Ongoing upload of Products" : "Can't activate a promotion with Ongoing upload of Products";

              if(importJob[0].formatted_status == 'Ongoing') {
                this.$notification['warning']({
                  message: 'Ongoing Upload',
                  duration: 0,
                  description: `${errMsg} [PromotionUploadProduct-${this.profileId}]. Click 'View Jobs' to review uploading process.`,
                  btn: h => {
                    return h(
                    'base-button',
                    {
                      props: {
                      type: 'warning',
                      class: 'btn-sm',
                      },
                      on: {
                      click: () => component_x.$router.push("/jobs"),
                      },
                    },
                    'View Jobs',
                    );
                  },
                });

                return true;
              }

              return false;
            },
            async getLocationTreeData(){
                // component_x.productLocationData = [];
                var apiData = await HTTPRequest.getRequest(
                            component_x.endPoint + "sites/get_valid_tree_sites",
                            null
                        );

                let treeSites = function (data, root) {
                var r = [], o = {};
                data.forEach(function (a) {
                if (o[a.key] && o[a.key].children) {
                    a.children = o[a.key] && o[a.key].children;
                }
                o[a.key] = a;
                if (a.parent_id === root) {
                    r.push(a);
                } else {
                    o[a.parent_id] = o[a.parent_id] || {};
                    o[a.parent_id].children = o[a.parent_id].children || [];
                    o[a.parent_id].children.push(a);
                }
                });
                return r;
                }(apiData, null);

                treeSites.forEach((el) => {
                    component_x.productLocationData.push({
                        id: el.id,
                        key: el.key,
                        title: el.title,
                        children: el.children
                    });
                });


                const RemoveKeyandRenametoID = (object, deleteKey) => {
                // if object
                // delete object[deleteKey];
                if(object["key"] != null){
                    if(!object["key"].includes("L",0)){
                    object["key"] = parseInt(object["key"]);
                    }
                }
                delete object["id"];

                Object.values(object).forEach((val) => {
                    if (typeof val !== 'object') return;
                        RemoveKeyandRenametoID(val, deleteKey);
                    })
                }


                RemoveKeyandRenametoID(component_x.productLocationData, 'key');

                // sort so that unspecified first
                this.productLocationData.sort((a, b) =>
                    a.title < b.title ? -1 : Number(a.title > b.title)
                );

                // console.log(this.productData)
                // end location tagging convert children and parent || tree data for site products
            },
            onCheckSiteId(selectedRowKeys) {
                console.log(selectedRowKeys)
                this.selectedRowKeys = selectedRowKeys;
            },
            checkImportJobs: async function() {
              //Check if with ongoing jobs
              const importJob = await HTTPRequest.getRequest(`${this.endPoint}import_jobs?profile_name=PromotionUploadProduct-${this.profileId}`, null)
              if(importJob != undefined && importJob.length > 0){
                if(importJob[0].formatted_status == 'Ongoing') {
                  this.$notification['success']({
                    message: 'Ongoing Upload',
                    duration: 0,
                    description: "There's an ongoing upload of CSV file for this Promotion. Click 'View Jobs' to review.",
                    btn: h => {
                      return h(
                      'base-button',
                      {
                        props: {
                        type: 'success',
                        class: 'btn-sm',
                        },
                        on: {
                        click: () => component_x.$router.push("/jobs"),
                        },
                      },
                      'View Jobs',
                      );
                    },
                  });
                } else if(importJob[0].formatted_status == 'With errors') {
                  this.$notification['warning']({
                    message: 'Upload Error',
                    duration: 0,
                    description: `CSV file uploaded with errors [PromotionUploadProduct-${this.profileId}] but you can ignore it and continue processing the promotion. Click 'View Jobs' button to review.`,
                    btn: h => {
                      return h(
                      'base-button',
                      {
                        props: {
                        type: 'warning',
                        class: 'btn-sm',
                        },
                        on: {
                        click: () => component_x.$router.push("/jobs"),
                        },
                      },
                      'View Jobs',
                      );
                    },
                  });
                }
              }
            },
            deleteButtonFormatter() {
                return `<button class="btn btn-sm btn-danger">Delete</button>`;
            },
            confirmDelete(rowData) {
                // ask for confirmation before deletion
                if (window.confirm("Are you sure you want to delete this record?")) {
                    this.deleteRecord(rowData);
                }
            },
            deleteRecord(rowData) {
                // remove the selected row from exceptData
                this.exceptData = this.exceptData.filter(
                    item => item.id_value !== rowData.id_value
                );
            }
        }
    }
</script>

<style scoped>
  .ant-table-fixed-header .ant-table-scroll .ant-table-header {
    overflow: hidden;
  }
  .ant-steps-item-process .ant-steps-item-icon{
    background: #65CB8F;
    border: #65CB8F;
  }
  .ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-description {
    white-space: nowrap;
    max-width: 100%;
  }
  .ant-steps-item-finish .ant-steps-item-icon {
    border-color: #AFB5BC;
    background-color: #fff;
  }
  .ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title:after {
    background-color: #AFB5BC;
  }

  .numberCircle {
    display:inline-block;
    border-radius:50%;
    border:2px solid;
    font-size:18px;
    background: #65CB8F;
    border: #65CB8F;
    color: #ffffff;
  }

  .numberCircle:before,
  .numberCircle:after {
    content:'\200B';
    display:inline-block;
    line-height:0px;
    padding-top:50%;
    padding-bottom:50%;
  }

  .numberCircle:before {
    padding-left:8px;
  }
  .numberCircle:after {
    padding-right:8px;
  }

  .filter-cont {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 20px;
  }

  .ellisis-cont .dropdown-menu .dropdown-item {
    cursor: pointer;
  }
</style>
